import LeadGenerator from "./LeadGenerator";
import StudyInNZ from "./StudyInNZ";
import React from "react";
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import img1 from './img1.jpg'
import img2 from './img2.jpg'
import img3 from './img3.jpg'
import img4 from './img4.jpg'
import review3 from './review3.jpeg'
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaWhatsapp, FaStar, FaGoogle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import KIWIORALogo from './kiwiora-logo.png'; // replace this file with the NEW circular logo (or point this path at it)
import './App.css';
import { FiMenu } from 'react-icons/fi'; // Modern SVG hamburger menu icon
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import VersionChecker from "./VersionChecker";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import founderPhoto from "./image.png"; // adjust name/path if different

// ─────────────────────────────────────────────
// BRAND PALETTE (single source of truth)
// ─────────────────────────────────────────────
const palette = {
  green: "#0D4B2D",     // Deep Emerald Green – header, H1/H2, banners, footer
  gold: "#B8860B",      // Antique Gold – borders, icon frames, badges, highlights
  cream: "#FAF8F3", 
  cream2: "#f0eee9",    // Warm Cream – main page background
  white: "#FFFFFF",     // Pure White – cards, forms, checklist boxes
  red: "#C0392B",       // Crimson Red – primary CTA buttons
  redDark: "#A93226",   // Crimson hover state
  text: "#14241B",      // Dark Forest Charcoal – body text
  muted: "#4A5A50",     // softened charcoal for secondary text
  goldBorder: "rgba(184, 134, 11, 0.35)",
  goldShadow: "0 8px 24px rgba(184, 134, 11, 0.12)",
  goldShadowHover: "0 12px 32px rgba(184, 134, 11, 0.22)",
};

const reviewImages = [review3];
const ReviewImageCard = styled.div`
  min-width: 520px;     /* BIGGER CARD */
  max-width: 520px;
  flex-shrink: 0;

  border-radius: 18px;
  overflow: hidden;
  background: ${palette.white};
  border: 1px solid ${palette.goldBorder};

  box-shadow: ${palette.goldShadow};
`;


const ReviewImage = styled.img`
  width: 100%;
  height: auto;
  display: block;

`;


const PrivacyModal = ({ onClose }) => (
 <div style={{
  position: 'fixed', inset: 0, background: 'rgba(20,36,27,0.55)', 
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
 }}>
  <div style={{
   background: palette.white, color: palette.text, maxWidth: '800px', maxHeight: '90vh', 
   overflowY: 'auto', padding: '2rem', borderRadius: '8px', position: 'relative',
   borderTop: `4px solid ${palette.gold}`
  }}>
   <button 
   onClick={onClose} 
   aria-label="Close"
   style={{ position: 'absolute', top: '1rem', right: '1rem', cursor: 'pointer', background: 'none', border: 'none', fontSize: '1.6rem', color: palette.green }}
   >
   ×
   </button>
   <h2 style={{ color: palette.green }}>Privacy Policy</h2>
   <div>
   <p><strong>Introduction</strong><br/>
   This privacy policy defines our practices for collecting, using, storing, and protecting personal information from users who visit our website. By using the site, you agree to these terms.</p>
   
   <h3 style={{ color: palette.green }}>Collection of Personal Information</h3>
   <p>We collect information you voluntarily provide, such as name, email address, and contact details.</p>
   
   <h3 style={{ color: palette.green }}>Use of Personal Information</h3>
   <ul>
     <li>Enhance services and website functionality</li>
     <li>Respond to inquiries and requests</li>
     <li>Personalize your experience</li>
     <li>Send updates/newsletters (with consent)</li>
     <li>Comply with laws</li>
     <li>Protect rights and safety</li>
   </ul>
   
   <h3 style={{ color: palette.green }}>Disclosure of Personal Information</h3>
   <ul>
     <li>With your consent</li>
     <li>To trusted service providers under confidentiality</li>
     <li>As required by law</li>
     <li>In business transfers (merger/acquisition)</li>
   </ul>
   
   <h3 style={{ color: palette.green }}>Cookies and Tracking</h3>
   <p>We use cookies for IP address, browser type, and usage stats to improve services. Manage via browser settings; disabling may affect functionality.</p>
   
   <h3 style={{ color: palette.green }}>Data Security</h3>
   <p>Comprehensive measures protect data, though no internet transmission is 100% secure.</p>
   
   <h3 style={{ color: palette.green }}>Your Rights</h3>
   <p>Access, correct, delete data, or opt out of marketing. Contact: info@kiwiora.in</p>
   
   <h3 style={{ color: palette.green }}>Data Retention & External Links</h3>
   <p>Retained as needed for policy purposes. Review third-party site policies separately.</p>
   
   <h3 style={{ color: palette.green }}>Changes & Contact</h3>
   <p>Updates posted here take effect immediately. Questions: info@kiwiora.in</p>
   </div>
  </div>
 </div>
);


function ScrollToTop() {
 const { pathname } = useLocation();
 useEffect(() => {
  window.scrollTo(0, 0);
 }, [pathname]);
 return null;
}

// Custom hook for responsive detection 
function useWindowSize() {
 const [windowSize, setWindowSize] = useState({ width: 1200, height: 800 });
 
 useEffect(() => {
  const handleResize = () => {
   setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };
  
  window.addEventListener('resize', handleResize);
  handleResize(); // Initial check
  
  return () => window.removeEventListener('resize', handleResize);
 }, []);
 
 return windowSize;
}

const TwoColumnSection = styled.section`
 display: flex;
 align-items: flex-start;
 justify-content: center;
 gap: 24px;
 padding: 24px 16px;
 max-width: 1200px;
 margin: 0 auto;

 & > * {
  flex: 1;
 }

 @media (max-width: 900px) {
  flex-direction: column;
 }
`;

const TypingHeroTitle = styled.h1`
  font-size: 3rem;
  font-family: 'Fira Sans';
  font-weight: 900;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-align: left;
  width: 100%;
  padding: 24px;
  color: ${palette.green};

  /* desktop only */
  @media (min-width: 1440px) {
    transform: translateX(-40px);  /* move slightly left */
    /* or use: margin-left: -40px; if you prefer */
     padding: 24px 16px 24px 1px;
  }
`;



//Typing animation
function TypingHeroH1({ text, ...props }) {
 const [displayed, setDisplayed] = React.useState('');
 React.useEffect(() => {
  let index = 0;
  const interval = setInterval(() => {
   if (index <= text.length) {
   setDisplayed(text.slice(0, index));
   index++;
   } else {
   clearInterval(interval);
   }
  }, 30); // speed in ms per character
  return () => clearInterval(interval);
 }, [text]);
 return (
  <h1 {...props}>{displayed}</h1>
 );
}


const GlobalStyle = createGlobalStyle`
 @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@200;400;500;600;700;800;900&display=swap');
 
 html, body, #root {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  background: ${palette.cream}; /* Warm Cream page background */
    font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: ${palette.text}; /* Dark Forest Charcoal body text */
 }
 
 * {
  box-sizing: border-box;
   font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif;
 }
 
 a {
  color: inherit;
  text-decoration: none;
  transition: color 0.25s ease;
 }
 a:hover,
 a:focus {
  color: ${palette.gold}; /* Antique Gold hover/focus */
  outline: none;
 }

 button {
  font-family: inherit;
 }

 /* "Connect with us" WhatsApp pill – calm, on-brand (overrides App.css glow) */
 .whatsapp-pill,
 .whatsapp-link .whatsapp-pill {
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  background: transparent !important;
  border: 1.5px solid ${palette.gold} !important;
  border-radius: 999px !important;
  padding: 6px 16px !important;
  color: ${palette.cream} !important;
  box-shadow: none !important;
  text-shadow: none !important;
  filter: none !important;
  animation: none !important;
  transition: background 0.2s ease, color 0.2s ease !important;
 }
 .whatsapp-pill .whatsapp-text {
  color: inherit !important;
  font-weight: 600 !important;
  text-shadow: none !important;
 }
 .whatsapp-pill .whatsapp-icon {
  color: #25D366 !important;
  font-size: 1.2rem !important;
  filter: none !important;
 }
 .whatsapp-pill:hover,
 .whatsapp-pill:focus {
  background: ${palette.gold} !important;
  color: ${palette.white} !important;
  box-shadow: none !important;
 }
 .whatsapp-pill:hover .whatsapp-icon,
 .whatsapp-pill:focus .whatsapp-icon {
  color: ${palette.white} !important;
 }
 .whatsapp-pill::before,
 .whatsapp-pill::after {
  display: none !important;
 }

  .burger-menu-btn {
 display: none;
}
@media (max-width: 700px) {
 .burger-menu-btn {
  display: block;
 }
}
   @media (min-width: 1201px) {
    .HeroImageGrid { max-width: 900px; margin: 0 auto; }
    .Nav ul { gap: 36px; }
    .ServicesGrid { grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); }
  }
  
  @media (min-width: 1600px) {
    .Container { max-width: 1400px; padding: 0 16px; }
    .ServicesGrid { grid-template-columns: repeat(3, 1fr); gap: 48px; }
    .MainSectionTitle { font-size: 2.8rem; }
  }
  
  @media (min-width: 2000px) {
    .HeroContent { max-width: 700px; }
    .HeroImageGrid { max-width: 1000px; }
  }

`;

const HeroDesktopInner = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 32px;

  /* only big desktops, covers 1920×1080 */
  @media (min-width: 1440px) {
    max-width: 1300px;   /* controls visual width */
    margin: 0 auto;      /* centers block */
    transform: translateX(40px); /* slight push to the right */
  }
`;


const TopBar = styled.div`
 background: ${palette.green};
 color: ${palette.cream};
 font-size: 1rem;
 font-weight: 400;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 4px 28px;
 min-height: 38px;
 border-radius: 0;
 width: 100%;
 margin: 0;
 box-shadow: none;      /* NO card look on desktop! */

 @media (max-width: 700px) {
  flex-direction: column;
  gap: 11px;
  justify-content: flex-start;
  align-items: stretch;
  padding: 15px 11px 12px 11px;
  min-height: 36px;
  border-radius: 18px;
  width: 93vw;
  max-width: 430px;
  margin: 0px auto 11px auto;
  box-shadow: 0 4px 14px rgba(13, 75, 45, 0.35);
 }
`;





const TopBarLeft = styled.div`
 display: flex;
 gap: 18px;
 align-items: flex-start;
 justify-content: flex-start;

 @media (max-width: 700px) {
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  font-size: 1rem;
  margin-bottom: 0;
  padding: 0;
  width: 100%;
 }
`;

const TopBarRight = styled.div`
 display: flex;
 align-items: center;
 gap: 10px;
 justify-content: flex-end;

 @media (max-width: 700px) {
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  font-size: 1rem;
  width: 100%;
  margin-top: 0;
  padding: 0;
 }
`;


const TopBarPhone = styled.a`
 background: rgba(184, 134, 11, 0.15);
 color: ${palette.gold};
 font-weight: 500;
 border-radius: 999px;
 padding: 10px 24px;
 margin-left: 0;
 font-size: 1.13rem;
 text-decoration: none;
 transition: background 0.2s;
 display: block;
 text-align: center;
 box-shadow: none;

 &:hover, &:focus {
  background: ${palette.gold};
  color: ${palette.white};
  outline: none;
 }

 @media (max-width: 700px) {
  width: 50%;
  margin-bottom: 6px;
  text-align: right;
  padding: 5px 9px;
  font-size: 1rem;
 }
`;

const MobileHeaderRow = styled.div`
 display: none;

 @media (max-width: 700px) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 6px;
 }
`;



const Container = styled.div`
 max-width: 1200px;
 margin: auto;
   padding: 80px 0 24px;  


  @media (max-width: 700px) {
    padding: 10px 16px 64px;  /* top | sides | bottom */
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }

`;
const HeaderWrapper = styled.header`
 background: ${palette.green}; /* Deep Emerald Green top menu bar */
 border-bottom: 2px solid ${palette.gold};
 width: 100%;
 position: sticky;
 top: 0;
 z-index: 100;
 box-shadow: 0 2px 10px rgba(13, 75, 45, 0.25);
 min-height: 80px;
 border-radius: 0;

 @media (max-width: 700px) {
   width: 100vw !important;
   min-width: 0;
   border-radius: 0 0 0px 0px;
   min-height: 54px;
   box-shadow: 0 4px 10px rgba(13, 75, 45, 0.2);
 }
`;

const HeaderContent = styled.div`
 display: flex;
 align-items: center;
 justify-content: space-between;
 width: 100%;
 min-width: 0;  
 flex-wrap: nowrap;
 gap: 0;
 min-height: 72px;
 padding: 0 24px;

 @media (max-width: 700px) {
   flex-direction: column;
   align-items: stretch;
   gap: 8px;
   min-height: 56px;
   padding: 0 8px;
 }
`;





const Logo = styled(Link)`
 font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif; font-weight: 800;
 font-size: 2.1rem;
 letter-spacing: 1px;
   display: flex;
 align-items: center;
 margin-left: 0; 
 color: ${palette.white};
 text-decoration: none;
 transition: color 0.24s;
 &:hover,
 &:focus {
   color: ${palette.gold};
   outline: none;
 }
`;

const LogoRow = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 width: 100%;
 gap: 12px;
`;

const NavMobile = styled.nav`
 position: absolute;       // instead of fixed: anchors to header
 top: 100%;             // drops below MobileHeaderRow
 left: 0;
 width: 100vw;
 max-width: 99vw;
 background: ${palette.green};
 border-top: 1px solid ${palette.goldBorder};
 border-radius: 0 0 22px 22px;
 box-shadow: 0 10px 24px rgba(13, 75, 45, 0.25);
 z-index: 25;
 animation: fadeInDown 0.19s cubic-bezier(.33,1.38,.59,.95);

 @keyframes fadeInDown {
   from {
    opacity: 0;
    transform: translateY(-14px);
   }
   to {
    opacity: 1;
    transform: translateY(0);
   }
 }

 ul {
   display: flex; flex-direction: column; gap: 10px;
   padding: 8px 0 18px 0; margin: 0; list-style: none;
 }

 li {
   width: 100%;
   /* Add this so all child links get block highlighting */
   a {
    color: ${palette.cream};
    font-weight: 400;
    font-size: 1rem;
    text-decoration: none;
    padding: 11px 18px;
    border-radius: 16px;
    transition: background 0.18s, color 0.18s;
    display: block;

    &:hover,
    &:focus,
    &[aria-current="page"] {
     background: ${palette.cream};
     color: ${palette.green};
     outline: none;
    }
   }
 }

 @media (min-width: 701px) {
   display: none;
 }
`;


const Nav = styled.nav`
 flex: 1;
 display: flex;
 justify-content: right;
 align-items: right;
 flex-wrap: nowrap;  
 ul {
   list-style: none;
   display: flex;
   gap: 28px;
   padding: 0;
   margin: 0;

   @media (max-width: 700px) {
    display: none;
   }
 }

 li {
font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif;   
  font-weight: 600;
   font-size: 1.2rem;
   a {
    color: ${palette.cream};
    text-decoration: none;
    transition: color 0.22s;
    padding: 4px 7px;
    &:hover,
    &:focus {
     color: ${palette.gold};
     outline: none;
    }
   }
 }
`;

const ButtonPrimary = styled(Link)`
 background-color: ${palette.red};
 color: ${palette.white};
 font-size: 1.1rem;
 font-weight: 700;
 padding: 10px 26px;
 border-radius: 12px;
 cursor: pointer;
 display: inline-block;
 margin-left: 24px;

 &:hover, &:focus {
   background-color: ${palette.redDark};
   color: ${palette.white};
   outline: none;
 }

 @media (max-width: 700px) {
   width: 99vw;
   max-width: 355px;
   margin: 12px auto 7px auto;
   display: block;
   font-size: 1.17rem;
    text-align: center;

   font-weight: 700;
   letter-spacing: 0.5px;
   border-radius: 17px;
   box-shadow: 0 4px 14px rgba(192, 57, 43, 0.25);
   transform: none;
 }
`;



const ButtonPrimary1 = styled(Link)`
 background: ${palette.red};
 color: ${palette.white};
 font-size: 1.11rem;
font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif; font-weight: 700;
 border: none;
 padding: 18px 38px;
 border-radius: 10px;
 text-align: center;
 cursor: pointer;
 box-shadow: 0 2px 10px rgba(192, 57, 43, 0.2);
 transition: background 0.18s, transform 0.18s;
 outline: none;
 &:hover,
 &:focus {
   background: ${palette.redDark};
   color: ${palette.white};
   transform: scale(1.05);
   outline: none;
 }
    @media (min-width: 700px) {
   width: auto;
   margin: 0;
   border-radius: 12px;
   display: inline-block;
   padding: 10px 26px;
   box-shadow: none;
   text-align: left;
 }
`;


const fadeInUp = keyframes`
 from {
   opacity: 0;
   transform: translateY(30px);
 }
 to {
   opacity: 1;
   transform: translateY(0);
 }
`;


// --- 2. THE STYLES (Add with your other styled components) ---

const ReviewsSection = styled.section`
  background-color: ${palette.cream};
  padding: 2rem 0;
  width: 100vw;
  margin: 0 -1rem;
  position: relative;
  overflow: visible !important;
  
  @media (min-width: 769px) {
    margin: 0;
    width: 100%;
    padding: 2rem 1rem;  // Add side padding for desktop
  }
`;




const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  h2 {
    font-size: 2.5rem;
    font-weight: 800;
    color: ${palette.green};
    margin-bottom: 10px;
  }
      /* 📱 Mobile styles */
  @media (max-width: 768px) {
    margin-bottom: 24px;

    h2 {
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 1.3;
    }
  }
`;

// THIS IS THE SCROLL CONTAINER
const ScrollContainer = styled.div`
  display: flex;             /* Puts items in a row */
  gap: 20px;                 /* Space between cards */
  overflow-x: auto;          /* Allows scrolling sideways */
  padding: 20px;             /* Padding so shadows don't get cut off */
  
  /* These lines hide the ugly scrollbar but keep functionality */
  scrollbar-width: none;      /* Firefox */
  -ms-overflow-style: none;   /* IE/Edge */
  &::-webkit-scrollbar { 
    display: none;            /* Chrome/Safari */
  }

  /* smooth scrolling feel */
  -webkit-overflow-scrolling: touch; 
`;

const ReviewCard = styled.div`
  min-width: 300px;  /* IMPORTANT: Forces the card to stay 300px wide */
  max-width: 300px;  
  background: ${palette.white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${palette.goldShadow};
  border: 1px solid ${palette.goldBorder};
  flex-shrink: 0;    /* IMPORTANT: Prevents card from squishing */
  
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ReviewAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover; /* Ensures image doesn't stretch weirdly */
  border: 2px solid ${palette.gold};
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  h4 {
    margin: 0;
    font-size: 0.95rem;
    color: ${palette.text};
  }
  span {
    font-size: 0.8rem;
    color: ${palette.muted};
  }
`;

const StarsRow = styled.div`
  display: flex;
  color: ${palette.gold};
  font-size: 1rem;
`;

const ReviewBody = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${palette.text};
`;
// --- END OF REVIEW STYLES ---

const HeroSection = styled.section`
 background: ${palette.cream};
 color: ${palette.text};
 border-bottom: 1px solid ${palette.goldBorder};
 min-height: 100vh;     /* fill full viewport height */
 display: flex;
 flex-direction: row;
 justify-content: flex-start;
 align-items: flex-start;
 padding: 0px; /* add bottom padding instead of margin */
 margin: 0;
 position: relative; 

 @media (max-width: 700px) {
   min-height: auto;       /* mobile: no forced height */
   display: block;
   width: 100vw;
   padding: 24px 16px 24px 1px; /* small, even padding */
 }
  /* large desktop: strict 2-column grid */
  @media (min-width: 1440px) {
    display: grid;
    grid-template-columns: 1.1fr 1.2fr; /* left vs right width */
    column-gap: 48px;
    justify-content: center;
      min-height: auto;  
       padding: 24px 16px 24px 1px;
  }
 
`;

// LEFT COLUMN: Text Content
const HeroContent = styled.div`
 flex: 1;
 max-width: 610px;
 display: flex;
    /* vertical centering inside grid cell */
 align-items: flex-start; 
 flex-direction: column;
 justify-content: flex-start;
 align-items: flex-start;
   margin-left: 30px;           /* Move headline/text right */

     @media (min-width: 1440px) {
    flex: 1;          /* grow with the row */
    max-width: none; padding: 40px; /* remove the cap so text block can widen a bit */
  }

`;
const HeroContentmobile = styled.div`
 flex: 1;
 max-width: 610px;
 display: flex;
 flex-direction: column;
 justify-content: flex-start;
 align-items: flex-start;
   margin-left: 10px;           /* Move headline/text right */


`;
// RIGHT COLUMN: Image
const HeroImageGrid = styled.div`
 display: grid;
 grid-template-columns: 1fr 1fr;
 grid-template-rows: 1fr 1fr;
 gap: 12px;
 justify-items: center;
   align-self: center;

 margin-right: 16px;
 padding: 0;
 width: 100%;
 max-width: 770px;
 min-width: 380px;

  @media (min-width: 1440px) {
    max-width: none;   /* allow it to grow */
    width: 100%;       /* take remaining space in the row */
  }

 @media (max-width: 700px) {
   grid-template-columns: 1fr;
   grid-template-rows: unset;
   gap: 18px;
   min-width: 0;
   max-width: 100vw;
   width: 100vw;
   margin-right: 0;
 }
`;



const HeroGridImg = styled.img`
 width: 100%;
 height: 200px;
 object-fit: cover;
 border-radius: 22px;
 border: 1px solid ${palette.goldBorder};
 box-shadow: 0 8px 32px rgba(13, 75, 45, 0.15);
 display: block;
 margin: 12px auto;

 ${props =>
   props.contain &&
   `
    object-fit: contain;
    object-position: center;
    background: #ffffff;
   `
 }

   @media (min-width: 1440px) {
    aspect-ratio: 3 / 1;  /* wide, not tall */
  }
 @media (max-width: 700px) {
   width: 96vw;
   max-width: 380px;
   margin: 14px auto;
   height: 165px;
   border-radius: 18px;
 }
`;




const HeroSubtitle = styled.p`
 font-size: 1.35rem;
font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif; color: ${palette.text};
 font-weight: 400;
 max-width: 570px;
 text-align: left;
 width: 100%; 
`;

const HeroSubtitlemobile = styled.p`
 font-size: 1rem;
font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif; color: ${palette.text};
 font-weight: 400;
 margin-bottom: 0px;
 max-width: 570px;
 text-align: center;
 width: 100%;
 
`;
const HeroBtn = styled(Link)`
 margin-top: 0px;
 padding: 10px 36px;
 border-radius: 10px;
 background: ${palette.red};
 color: ${palette.white};
 font-weight: 700;
 font-size: 1.09rem;
 border: none;
 text-align: left;
 box-shadow: 0 4px 14px rgba(192, 57, 43, 0.25);
 display: block;
 outline: none;
 margin-left: 20px;
 transition: background 0.18s, transform 0.18s;

 &:hover, &:focus {
   background: ${palette.redDark};
   color: ${palette.white};
   transform: translateY(-1px);
 }

 @media (max-width: 768px) {
   display: block;       /* block element */
   width: fit-content;    /* shrink to content width */
   padding: 10px 20px;    /* smaller on mobile */
   font-size: 0.95rem;
   margin: 16px auto 0;   /* centers the button */
   text-align: center;    /* centers text inside */
 }
`;



// Section Title
const MainSectionTitle = styled.h2`
 text-align: center;
 font-size: 2.2rem;
 font-weight: 1000;
 margin-bottom: 28px;
 letter-spacing: 0.04em;
 line-height: 1.3;
font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
                 system-ui, sans-serif;
                  color: ${palette.green};

 span {
   color: ${palette.gold};
   font-weight: 800;
   font-family: inherit;
 }
    @media (max-width: 700px) {
   font-size: 1.3rem;
   margin-bottom: 32px;
 }
`;

// Stats Section
const StatsSection = styled.section`
 background-color: ${palette.cream};
 padding: 56px 0;
`;

const StatsGrid = styled.div`
 display: flex;
 justify-content: center;
 gap: 64px;
 flex-wrap: wrap;
`;

const StatCard = styled.div`
 background: ${palette.white};
 border: 1px solid ${palette.goldBorder};
 padding: 36px 48px;
 border-radius: 14px;
 box-shadow: ${palette.goldShadow};
 text-align: center;
 min-width: 180px;
 flex-grow: 1;
 transition: transform 0.3s ease, box-shadow 0.3s ease;
 cursor: default;

 &:hover,
 &:focus-within {
   transform: translateY(-5px);
   box-shadow: ${palette.goldShadowHover};
 }

 h3 {
   font-size: 3.2rem;
   color: ${palette.gold};
   margin-bottom: 14px;
 }
 p {
   font-weight: 700;
   font-size: 1.15rem;
   color: ${palette.green};
 }
`;

// Services Section
const ServicesSection = styled.section`
 padding: 16px 0;
`;

const ServicesGrid = styled.div`
 display: grid;
 grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
 gap: 36px;

 @media (max-width: 700px) {
   grid-template-columns: 1fr;
   gap: 18px;
   padding: 0 6px;
 }
`;

const ServiceCard = styled.div`
 background: ${palette.white};
 border: 1px solid ${palette.goldBorder};
 border-radius: 12px;
 padding: 18px 18px 16px; 
 box-shadow: ${palette.goldShadow};
 text-align: center;
 cursor: pointer;
 transition: box-shadow 0.35s ease, transform 0.3s ease;
 display: flex;
 flex-direction: column;
 gap: 6px;

 &:hover,
 &:focus {
   box-shadow: ${palette.goldShadowHover};
   transform: translateY(-3px);
   outline: none;
 }

 @media (max-width: 700px) {
   padding: 28px 10px;
   border-radius: 8px;
   gap: 9px;
 }

 h3 {
   font-size: 1.5rem;
   margin-bottom: 8px;
   color: ${palette.green};
   @media (max-width: 700px) {
    font-size: 1.18rem;
   }
 }
 p {
   color: ${palette.text};
   font-size: 1.05rem;
   line-height: 1.6;
   flex-grow: 1;
   @media (max-width: 700px) {
    font-size: 0.97rem;
   }
 }
`;

// About Section
const AboutSection = styled.section`
 background-color: ${palette.cream};
 padding: 56px 0;
 text-align: center;

 p {
   max-width: 780px;
   margin: 0 auto;
   font-size: 1.2rem;
   line-height: 1.7;
   color: ${palette.text};
   letter-spacing: 0.02em;
 }
   
`;

// FAQ Section
// Section background
const FAQSection = styled.section`
 background: ${palette.cream};
 padding: 16px 0;
  padding-top: 0px;  
    margin-top: 0;

`;


const FAQListWrapper = styled.div`
 max-width: 650px;      /* Reduce overall width */
 margin: 0 auto;
`;

const FAQItem = styled.div`
 background: ${palette.white};
 border: 1px solid ${palette.goldBorder};
 border-radius: 16px;
 margin-bottom: 18px;
 box-shadow: ${palette.goldShadow};
 overflow: hidden;
 transition: box-shadow 0.15s;
`;

const FAQQuestion = styled.button`
 width: 100%;
 background: none;
 border: none;
 padding: 20px 30px;
 font-size: 1.13rem;
 font-weight: 600;
 color: ${palette.text};
 text-align: left;
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-radius: 16px;
 cursor: pointer;
 outline: none;
 transition: background 0.12s;

 span {
   color: ${palette.gold};
   font-size: 1.45rem;
   margin-left: 15px;
   font-weight: 700;
 }
`;

const FAQAnswer = styled.div`
 max-height: ${({ expanded }) => (expanded ? "1000px" : "0")};
 padding: ${({ expanded }) => (expanded ? "20px 28px" : "0 28px")};
 font-size: 1rem;
 color: ${palette.text};
 line-height: 1.7;
 overflow: hidden;
 transition: max-height 0.4s ease, padding 0.4s ease;
`;


//Appointment
const AppointmentWrapper = styled.section`
 max-width: 520px;
 margin: auto auto;         /* gap above/below */
 padding: 18px 18px;         /* inner spacing */
 background: ${palette.green};
 border: 1px solid ${palette.gold};
 border-radius: 16px;        /* rounded corners */
 box-shadow: 0 16px 40px rgba(13, 75, 45, 0.18);
`;


const FormTitle = styled.h2`
 text-align: center;
 font-size: 1.2rem;
 font-weight: 500;
 color: ${palette.cream};
 margin-bottom: 1px;
`;

const FormSubtitle = styled.p`
 text-align: center;
 color: rgba(250, 248, 243, 0.8);
 font-size: 0.8rem;
 margin-bottom: 8px;
`;

const FormContainer = styled.form`
 background: ${palette.white};
 border-radius: 22px;
 max-width: 440px;
 margin: 0 auto;
 padding: 32px 28px 24px 28px;
 box-shadow: 0 8px 36px rgba(0, 0, 0, 0.12);
 display: flex;
 flex-direction: column;
 gap: 10px;       /* smaller vertical gaps */

`;

const Row2 = styled.div`
 display: flex;
 gap: 10px;
`;

const Label = styled.label`
 font-weight: 600;
 color: ${palette.text};
 font-size: 0.9rem;
 margin-bottom: 2px;
`;
const Input = styled.input`
 background: ${palette.cream};
 color: ${palette.text};
 border-radius: 9px;
 border: 1px solid ${palette.goldBorder};
  padding: 8px 10px;
 font-size: 0.9rem;
 outline: none;
 margin-bottom: 4px;
 width: 100%;
 transition: border 0.14s;
 &:focus {
   border: 1.5px solid ${palette.gold};
 }
`;

const Select = styled.select`
 background: ${palette.cream};
 color: ${palette.text};
 border-radius: 9px;
 border: 1px solid ${palette.goldBorder};
 padding: 8px 10px;
 outline: none;
 font-size: 0.9rem;
 margin-bottom: 4px;
 width: 100%;
 transition: border 0.14s;
 &:focus {
   border: 1.5px solid ${palette.gold};
 }
`;

const Textarea = styled.textarea`
 background: ${palette.cream};
 color: ${palette.text};
 border-radius: 9px;
 border: 1px solid ${palette.goldBorder};
 padding: 8px 10px;
 outline: none;
 font-size: 0.9rem;
 min-height: 80px;  /* shorter message box */
 width: 100%;
 &:focus {
   border: 1.5px solid ${palette.gold};
 }
`;

const CheckboxLabel = styled.label`
 font-size: 0.96rem;
 color: ${palette.text};
 display: flex;
 align-items: center;
 gap: 10px;
`;

// Crimson Red CTA button
const SendBtn = styled.button`
 margin-top: 10px;
 width: 100%;
 background: ${palette.red};
 color: ${palette.white};
 font-size: 1.11rem;
 font-weight: 700;
 border: none;
 border-radius: 12px;
 padding: 13px 0;
 box-shadow: 0 2px 12px rgba(192, 57, 43, 0.2);
 cursor: pointer;
 transition: background 0.15s, transform 0.17s;

 &:hover,
 &:focus {
   background: ${palette.redDark};
   transform: scale(1.03);
   outline: none;
 }

 &:disabled {
   opacity: 0.75;
   cursor: wait;
   transform: none;
 }
`;

// Footer
const FooterWrapper = styled.footer`
 background-color: ${palette.green};
 border-top: 3px solid ${palette.gold};
 padding: 24px 10px;
 text-align: center;
 color: ${palette.cream};
 font-size: 1rem;
 font-weight: 500;
 user-select: none;

 @media (max-width: 700px) {
   padding: 20px 8px;
   font-size: 1rem;
   line-height: 1.55;
 }
`;


const FooterLink = styled.a`
 display: inline-flex;
 align-items: center;
 gap: 5px;
 color: ${palette.cream};
 text-decoration: none;
 font-weight: 600;
 font-size: 1.05rem;
 padding: 6px 8px;
 border-radius: 10px;
 transition: background 0.13s, color 0.13s;

 &:hover,
 &:focus {
   background: rgba(255, 255, 255, 0.1);
   color: ${palette.gold};
   outline: none;
 }
`;

const FooterSocial = styled.span`
 display: flex;
 justify-content: center;
 flex-wrap: wrap;
 gap: 10px;
 margin: 7px 0;
`;


// Scroll to top button
const ScrollTopButton = styled.button`
 position: fixed;
 bottom: 28px;
 right: 28px;
 background-color: ${palette.green};
 border: 2px solid ${palette.gold};
 border-radius: 50%;
 height: 56px;
 width: 56px;
 color: ${palette.white};
 font-weight: 700;
 font-size: 1.7rem;
 cursor: pointer;
 box-shadow: 0 12px 26px rgba(13, 75, 45, 0.3);
 transition: background-color 0.3s ease, transform 0.25s ease;
 display: ${({ visible }) => (visible ? "block" : "none")};
 z-index: 120;

 &:hover,
 &:focus {
   background-color: ${palette.red};
   transform: scale(1.1);
   outline: none;
 }

 &:focus-visible {
   outline: 3px solid ${palette.gold};
   outline-offset: 3px;
 }
    @media (max-width: 700px) {
   bottom: 20px; /* a bit higher on mobile */
   right: 20px;
   height: 50px;
   width: 50px;
   font-size: 1.4rem;
 }
`;


const ContactGrid = styled.div`
 display: flex;
 gap: 32px;
 justify-content: center;
 margin-top: 38px;
 flex-wrap: nowrap;

 @media (max-width: 650px) {
   flex-wrap: wrap;
   flex-direction: column;
   gap: 18px;
   align-items: center;
 }
`;

const ContactCard = styled.a`
 background: ${palette.white};
 border: 1px solid ${palette.goldBorder};
 border-radius: 24px;
 box-shadow: ${palette.goldShadow};
 padding: 38px 20px 28px 20px;
 width: 250px;
 display: flex;
 flex-direction: column;
 align-items: center;
 text-decoration: none;
 transition: box-shadow 0.17s;
 cursor: pointer;

 &:hover, &:focus {
   box-shadow: ${palette.goldShadowHover};
   color: inherit;
 }

 @media (max-width: 650px) {
   width: 100%;
   max-width: 330px;
   margin: 0 auto;
 }
`;


const IconCircle = styled.div`
 width: 54px;
 height: 54px;
 background: ${palette.cream};
 border: 2px solid ${palette.gold};
 border-radius: 50%;
 margin-bottom: 18px;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 1.6rem;
 color: ${palette.gold};
`;

const CardHeading = styled.h3`
 font-size: 1.09rem;
 font-weight: 700;
 color: ${palette.green};
 text-align: center;
`;

const CardSub = styled.p`
 font-size: 1rem;
 font-weight: 600;
 color: ${palette.text};
 margin: 2px 0 6px 0;
 text-align: center;
`;

const CardDesc = styled.p`
 font-size: 0.97rem;
 color: ${palette.muted};
 margin-bottom: 12px;
 text-align: center;
`;

const CardButton = styled.div`
 background: ${palette.red};
 color: ${palette.white};
 font-size: 1.07rem;
 font-weight: 700;
 padding: 12px 0;
 width: 100%;
 text-align: center;
 border-radius: 15px;
 margin-top: 14px;
 cursor: pointer;
 box-shadow: none;
 transition: background 0.16s;
 &:hover {
   background: ${palette.redDark};
 }
`;

const successContainer = styled.div`
 width: 100vw;
 padding: 48px 32px;
 box-sizing: border-box;
 background: ${palette.cream};
`;

const SectionTitle = styled.h2`
 font-size: 2.7rem;
 letter-spacing: 0.02em;
 font-weight: 900;
 color: ${palette.green};
 text-align: center;
 margin-bottom: 14px;
`;

// Example SVG icons (gold icon frames)
const StatIcon = ({ name }) => {
 if (name === "users") return (
   <svg width="36" height="36" fill="none" stroke={palette.gold}><circle cx="18" cy="18" r="16" strokeWidth="2"/><path d="M18 24c-4 0-8 2-8 4v2h16v-2c0-2-4-4-8-4zm0-2a4 4 0 100-8 4 4 0 000 8z" strokeWidth="2"/></svg>
 );
 if (name === "target") return (
   <svg width="36" height="36" fill="none" stroke={palette.gold}><circle cx="18" cy="18" r="16" strokeWidth="2"/><circle cx="18" cy="18" r="8" strokeWidth="2"/><circle cx="18" cy="18" r="3" strokeWidth="2"/></svg>
 );
 if (name === "location") return (
   <svg width="36" height="36" fill="none" stroke={palette.gold}><circle cx="18" cy="18" r="16" strokeWidth="2"/><path d="M18 25c-5-6-8-9-8-12a8 8 0 1116 0c0 3-3 6-8 12z" strokeWidth="2"/></svg>
 );
 if (name === "trend") return (
   <svg width="36" height="36" fill="none" stroke={palette.gold}><circle cx="18" cy="18" r="16" strokeWidth="2"/><path d="M10 24l6-6 4 4 6-8" strokeWidth="2"/></svg>
 );
 return null;
};

const BrandGreen = palette.green;
const LightBg = palette.cream;
const CardBg = palette.white;
const AccentGold = palette.gold;
const staryellow = palette.gold;

const StatsGridsuccess = styled.div`
 display: grid;
 grid-template-columns: repeat(4, 1fr);
 gap: 32px;
 margin: 48px 0 56px 0;
 @media (max-width: 900px) {
   grid-template-columns: repeat(2, 1fr);
   gap: 18px;
 }
`;

const StatCardsuccess = styled.div`
 background: ${CardBg};
 border: 1px solid ${palette.goldBorder};
 border-radius: 20px;
 box-shadow: ${palette.goldShadow};
 text-align: center;
 padding: 36px 18px;
 display: flex;
 flex-direction: column;
 align-items: center;
`;

const StatNumber = styled.div`
 font-size: 2.4rem;
 font-weight: 800;
 color: ${BrandGreen};
 margin: 14px 0 6px 0;
`;

const StatLabel = styled.div`
 font-size: 1.18rem;
 color: ${palette.muted};
 font-weight: 600;
`;

const CategoriesBar = styled.div`
 display: flex;
 justify-content: center;
 gap: 14px;
 margin: 18px 0 34px 0;
 flex-wrap: wrap;
`;

const CategoryBtn = styled.button`
 background: ${props => props.active ? BrandGreen : CardBg};
 color: ${props => props.active ? "#fff" : BrandGreen};
 font-weight: 700;
 border: 1px solid ${palette.goldBorder};
 border-radius: 12px;
 padding: 10px 24px;
 font-size: 1.08rem;
 box-shadow: ${palette.goldShadow};
 cursor: pointer;
 transition: background 0.13s;
 outline: none;
 &:hover {
   background: ${BrandGreen};
   color: #fff;
 }
`;

const TestimonialGrid = styled.div`
 display: grid;
 grid-template-columns: repeat(2, 1fr);
 gap: 32px;
 @media (max-width: 900px) {
   grid-template-columns: 1fr;
 }
`;

const TestimonialCard = styled.div`
 background: ${CardBg};
 border: 1px solid ${palette.goldBorder};
 border-radius: 20px;
 box-shadow: ${palette.goldShadow};
 padding: 32px 22px 26px 22px;
 margin-bottom: 8px;
`;

const TestHeader = styled.div`
 display: flex;
 align-items: flex-start;
 justify-content: space-between;
 margin-bottom: 18px;
`;

const TestMeta = styled.div`
 display: flex;
 align-items: center;
 gap: 18px;
`;

const AvatarCircle = styled.div`
 width: 46px;
 height: 46px;
 background: ${BrandGreen};
 border: 2px solid ${AccentGold};
 color: #fff;
 font-weight: bold;
 font-size: 1.36rem;
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
`;

const TestInfo = styled.div`
 display: flex;
 flex-direction: column;
`;

const TestName = styled.div`
 font-weight: 700;
 font-size: 1.13rem;
 margin-bottom: 2px;
 color: ${BrandGreen};
`;

const TestLocation = styled.div`
 font-size: 0.95rem;
 color: ${palette.muted};
`;

const Badge = styled.span`
 display: inline-block;
 background: ${props => props.bg ? AccentGold : LightBg};
 color: ${props => props.bg ? "#fff" : BrandGreen};
 border: 1px solid ${AccentGold};
 font-size: 0.97rem;
 font-weight: 600;
 border-radius: 7px;
 padding: 3px 12px;
 margin-right: 8px;
`;

const Stars = styled.div`
 display: flex;
 align-items: center;
 gap: 4px;
 margin-bottom: 10px;
`;

const StoryText = styled.p`
 font-size: 1.04rem;
 margin-bottom: 18px;
 color: ${palette.text};
`;

const OutcomeBox = styled.div`
 background: ${LightBg};
 border-left: 3px solid ${AccentGold};
 border-radius: 10px;
 padding: 12px 0 12px 18px;
 font-size: 1rem;
 font-weight: 600;
 color: ${BrandGreen};
 margin-bottom: 17px;
`;

const TimelineRow = styled.div`
 display: flex;
 align-items: center;
 font-size: 0.97rem;
 font-weight: 500;
 color: ${palette.muted};
 margin-bottom: 0;
 gap: 8px;
`;

const HighlightsBar = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
`;

const HighlightTag = styled.span`
 background: ${AccentGold};
 color: #fff;
 border-radius: 8px;
 font-size: 0.92rem;
 padding: 3px 13px;
 font-weight: 600;
`;

const LoadMoreBtn = styled.button`
 background: ${BrandGreen};
 color: #fff;
 font-weight: 700;
 border: 1px solid ${AccentGold};
 border-radius: 16px;
 padding: 15px 48px;
 font-size: 1.08rem;
 margin: 38px auto 0 auto;
 display: block;
 cursor: pointer;
 box-shadow: ${palette.goldShadow};
 transition: background 0.14s;
 &:hover {
   background: ${palette.text};
 }
`;

const CTASection = styled.section`
 background: ${BrandGreen};
 border-top: 3px solid ${AccentGold};
 color: #fff;
 text-align: center;
 padding: 72px 0 66px 0;
 margin-top: 42px;
`;

const CTAButtons = styled.div`
 display: flex;
 gap: 16px;
 justify-content: center;
 margin-top: 28px;
 flex-wrap: wrap;
`;

const CTAButton = styled.a`
 background: ${props => props.primary ? palette.red : CardBg};
 color: ${props => props.primary ? "#fff" : BrandGreen};
 font-weight: 700;
 border-radius: 12px;
 padding: 16px 38px;
 font-size: 1.13rem;
 border: none;
 box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
 cursor: pointer;
 display: inline-block;
 text-decoration: none;
 &:hover {
   background: ${props => props.primary ? palette.redDark : LightBg};
   color: ${props => props.primary ? "#fff" : BrandGreen};
 }
`;
const BurgerButton = styled.button`
 background: none;
 border: none;
 padding: 2px;
 border-radius: 6px;
 color: ${palette.white};
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 2.3rem;
 cursor: pointer;
 transition: background 0.17s, box-shadow 0.17s, transform 0.13s;
 box-shadow: none;

 &:hover, &:focus {
   background: rgba(255, 255, 255, 0.15);
   color: ${palette.gold};
   transform: scale(1.08);
   outline: none;
 }

 @media (min-width: 701px) {
   display: none;
 }
`;

// Components

// Rectangular logo style – shows the complete logo (no cropping)
const circularLogoStyle = (size) => ({
  height: size,
  width: 'auto',          // keep the logo's natural proportions
  maxWidth: '220px',
  objectFit: 'contain',   // never crop any part of the logo
  borderRadius: '8px',
  border: `1px solid ${palette.gold}`,
  background: palette.cream2,
  padding: '4px 10px',
  verticalAlign: 'middle',
  display: 'block',
});

function Header() {
 const [menuOpen, setMenuOpen] = React.useState(false);

 return (
   <HeaderWrapper>
    <HeaderContent>
     {/* Desktop Logo (hidden on mobile) */}
   <Logo className="desktop-logo" to="/">
 <img
   src={KIWIORALogo}
   alt="KIWIORA Logo"
   style={{
    ...circularLogoStyle('68px'),
    marginLeft: '18px',
    marginRight: '6px',
   }}
 />
</Logo>


     {/* Mobile Logo and Hamburger */}
     <MobileHeaderRow>
 <Logo to="/">
   <img src={KIWIORALogo} alt="KIWIORA Logo"
    style={{ ...circularLogoStyle('52px'), margin: '6px 20px 6px 0' }} />
 </Logo>
 <BurgerButton
   onClick={() => setMenuOpen(!menuOpen)}
   aria-label="Open menu"
 >
   <FiMenu />
 </BurgerButton>
</MobileHeaderRow>


     {/* Desktop Nav (hidden on mobile) */}
     
<Nav aria-label="Primary">
 <ul>
   <li><Link to="/">Home</Link></li>
   <li><Link to="/services">Services</Link></li>
   <li><Link to="/about">About</Link></li>
   <li><Link to="/contact">Contact Us</Link></li>
   <li><Link to="/help">Help</Link></li>
   <li><Link to="/get-started">Get Started</Link></li>

   <li className="whatsapp-link">
    {/* <span className="whatsapp-text">Chat with us instantly</span> */}

    <a
     href="https://wa.me/919849995490"
     target="_blank"
     rel="noopener noreferrer"
     className="whatsapp-pill"
     aria-label="Chat on WhatsApp"
    >
     <span className="whatsapp-text">Connect with us</span>
     <FaWhatsapp className="whatsapp-icon" />
    </a>
   </li>
 </ul>
</Nav>



     {/* Desktop Get Appointment Button (hidden on mobile) */}
     {/* <ButtonPrimary to="/appointment">Get Appointment</ButtonPrimary> */}

     {/* Mobile Popup Menu */}
     {menuOpen && ( <>
      {/* Transparent overlay covering whole screen */}
        <div
         onClick={() => setMenuOpen(false)}
         style={{
           position: 'fixed',
           inset: 0,
           background: 'transparent',
           zIndex: 20,
         }}
        />
 <NavMobile>
   <ul>
    <li>
     <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
    </li>
    <li>
     <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
    </li>
    <li>
     <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
    </li>
    {/* <li>
     <Link to="/success-stories" onClick={() => setMenuOpen(false)}>Success Stories</Link>
    </li> */}
    <li>
     <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
    </li>
    <li>
     <Link to="/help" onClick={() => setMenuOpen(false)}>Help</Link>
    </li>
   </ul>
  
 </NavMobile> </>
)}

    
    </HeaderContent>
   </HeaderWrapper>
 );
}


function Hero() {
 const isMobile = useMediaQuery({ maxWidth: 700 });

 return (
   <HeroSection>
    {!isMobile ? (
     // DESKTOP
          <>
 <HeroContent style={{ flex: 1 }}>
       <TypingHeroTitle>
 <TypingHeroH1
         text="Your Trusted New Zealand Education Experts."
         style={{
           fontSize: '3rem',
           fontFamily: 'Fira Sans',
           fontWeight: 900,
           marginBottom: '22px',
           letterSpacing: '1px',
           textAlign: 'left',
           width: '100%',
           color: palette.green,
         }}
        />

        <HeroSubtitle>
         Shape Your Future, the Kiwi Way. 
          <p style={{  fontWeight: 500, fontSize: '1.6rem', color: palette.text }}>From the comfort of your home.</p>
</HeroSubtitle>
        </TypingHeroTitle>

        {/* Desktop button */}
        <HeroBtn to="/get-started">Book a Free Consultation</HeroBtn>
        
       </HeroContent>

       <HeroImageGrid>
        <HeroGridImg src={img4} alt="Top left" />
        <HeroGridImg src={img2} alt="Top right" />
        <HeroGridImg src={img3} alt="Bottom left" />
        <HeroGridImg src={img1} alt="Bottom right" />
       </HeroImageGrid>
           </>

    ) : (
     // MOBILE
     <>
       <HeroContentmobile>
        <TypingHeroH1
         text="Your Trusted New Zealand Education Experts."
         style={{
           fontSize: '1.75rem',
           fontFamily: 'Fira Sans, Segoe UI, Arial, sans-serif',
           fontWeight: 700,
           marginBottom: '10px',
           letterSpacing: '1px',
           textAlign: 'center',
           width: '100%',
           color: palette.green,
         }}
        />

        {/* Mobile subtitle */}
        <HeroSubtitlemobile>
         Shape Your Future, the Kiwi Way.
         <p style= {{marginTop: '2px', fontWeight: 400, fontSize: '1.2rem', color: palette.text }} >From the comfort of your home.</p>
        </HeroSubtitlemobile>

        {/* Mobile button */}
        <HeroBtn to="/appointment">Book a Free Consultation</HeroBtn>
       </HeroContentmobile>

       <HeroImageGrid>
        <HeroGridImg src={img4} alt="Top left" />
       </HeroImageGrid>
     </>
    )}
   </HeroSection>
 );
}




// function Statistics() {
//  return (
//   // <StatsSection>
//   //  <Container>
//   //   {/* <MainSectionTitle >Our Expertise in Numbers</MainSectionTitle > */}
//   //   <StatsGrid>
//   //     <StatCard tabIndex={0}>
//   //      <h3>12+</h3>
//   //      <p>Years of Experience</p>
//   //     </StatCard>
//   //     <StatCard tabIndex={0}>
//   //      <h3>3369+</h3>
//   //      <p>Successful Cases</p>
//   //     </StatCard>
//   //     <StatCard tabIndex={0}>
//   //      <h3>95%</h3>
//   //      <p>Client Satisfaction</p>
//   //     </StatCard>
//   //   </StatsGrid>
//   //  </Container>
//   // </StatsSection>
//  );
// }

const ServicespreviewGrid = styled.div`
 display: grid;
 grid-template-columns: repeat(2, minmax(0, 1fr));
 gap: 10px;

 @media (max-width: 760px) {
   grid-template-columns: 1fr;  /* stack on mobile */
 }
`;

function ServicesPreview() {
 const services = [
   {
    title: "Student Visa",
    description:
     "End-to-end support for admission, finances, and visa lodging so you can focus on your studies, not paperwork.",
   },
   {
    title: "Partner of Student Work Visa",
    description:
     "Guidance on eligibility, relationship proofs, financials, and complete work-visa application support for your partner.",
   },
   {
    title: "Dependent Visa",
    description:
     "Support for visas for children and dependents, including financial proofs, and smooth family settlement planning.",
   },
   {
    title: "Post-Study Work Visa",
    description:
     "Help with open work visa applications, next-step career planning, and clear guidance on pathways toward residency and PR.",
   },
 ];

 return (
   <ServicesSection>
    <Container>
     <MainSectionTitle>Our Core Services</MainSectionTitle>
     <ServicespreviewGrid>
       {services.map((svc, idx) => (
        <ServiceCard key={idx} tabIndex={0}>
         <h3>{svc.title}</h3>
         <p>{svc.description}</p>
        </ServiceCard>
       ))}
     </ServicespreviewGrid>
    </Container>
   </ServicesSection>
 );
}


function Services() {
   const { width: screenWidth } = useWindowSize();
 
 const isMobile = screenWidth < 768;
 const isTablet = screenWidth >= 768 && screenWidth < 1024;

 const services = [
   {
    title: "Student Visa",
    tagline: "Study your Bachelors or Masters in New Zealand.",
    description:
     "End-to-end support for admission, finances, and visa lodging so you can focus on your studies, not paperwork.",
   },
   {
    title: "Partner of Student Work Visa",
    tagline: "Bring your partner with you while you study.",
    description:
     "Guidance on eligibility, relationship proofs, financials, and complete work-visa application support for your partner.",
   },
   {
    title: "Dependent Visa",
    tagline: "Keep your family together in New Zealand.",
    description:
     "Support for visas for children and dependents, including financial proofs, and smooth family settlement planning.",
   },
   {
    title: "Post-Study Work Visa",
    tagline: "Turn your New Zealand degree into a career.",
    description:
     "Help with open work visa applications, next-step career planning, and clear guidance on pathways toward residency and PR.",
   },
 ];

 // shared style for the 4 visa-track cards
 const trackCard = {
   padding: isMobile ? "14px 14px 16px" : "18px",
   borderRadius: "16px",
   background: palette.white,
   border: `1px solid ${palette.goldBorder}`,
   boxShadow: palette.goldShadow,
   borderTop: `3px solid ${palette.gold}`,
 };
 const trackTitle = {
   fontWeight: 700,
   fontSize: isMobile ? "1rem" : "1.07rem",
   color: palette.green,
   letterSpacing: "-0.5px",
 };
 const trackList = {
   listStyleType: "disc",
   margin: 0,
   paddingLeft: "18px",
   fontSize: isMobile ? "0.9rem" : "0.97rem",
   color: palette.text,
   lineHeight: 1.6,
   display: "block",
 };

 return (
   <ServicesSection>
    <Container>
     <MainSectionTitle style={{ textAlign: "center", marginBottom: "10px" }}>
       Our Core Visa Services
     </MainSectionTitle>

     <p
       style={{
        maxWidth: "720px",
        margin: "0 auto 32px",
        textAlign: "center",
        color: palette.muted,
        fontSize: "1rem",
        lineHeight: 1.6,
       }}
     >
       KIWIORA provides focused visa and migration services for students and
       their families who want to <strong style={{ color: palette.text }}>study, work, and settle in New Zealand</strong>.
       Each service is designed to remove confusion and give you a clear,
       step‑by‑step plan.
     </p>

     <ServicesGrid>
       {services.map((svc, idx) => (
        <ServiceCard key={idx} tabIndex={0}>
         <h3
           style={{
            fontSize: "1.2rem",
            marginBottom: "6px",
            color: palette.green,
           }}
         >
           {svc.title}
         </h3>
         <p
           style={{
            fontWeight: 600,
            marginBottom: "8px",
            color: palette.text,
           }}
         >
           {svc.tagline}
         </p>
         <p
           style={{
            fontSize: "0.96rem",
            lineHeight: 1.6,
            color: palette.muted,
           }}
         >
           {svc.description}
         </p>
        </ServiceCard>
       ))}
     </ServicesGrid>

     {/* Visa type → services mapping as a compact, readable section */}
<div
 style={{
   marginTop: "40px",
   padding: isMobile ? "20px 14px 24px" : "28px 20px 32px",
   borderRadius: "18px",
   background: "rgba(184, 134, 11, 0.06)",
   border: `1px solid ${palette.goldBorder}`,
 }}
>
 <h2
   style={{
   fontSize: isMobile ? "1.1rem" : "1.35rem",
    marginBottom: isMobile ? "12px" : "18px",
    textAlign: "center",
    color: palette.green,
   }}
 >
   How KIWIORA Supports Each Visa Type
 </h2>

 <p
   style={{
    maxWidth: "680px",
    margin: "0 auto 24px",
    textAlign: "center",
    fontSize: isMobile ? "0.9rem" : "0.96rem",
    color: palette.muted,
    lineHeight: 1.6,
        paddingInline: isMobile ? "4px" : 0, // prevent text touching edges

   }}
 >
   Four focused service tracks designed to cover everything you need - 
   from admissions and visas to family support and post-study careers.
 </p>

 <div
   style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(0, 1fr))",
    gap: isMobile ? "12px" : "20px",
   }}
 >
   
   {/* Student Visa */}
   <div style={trackCard}>
     <div
     style={{
       display: "flex",
       alignItems: "center",
       marginBottom: isMobile ? "4px" : "8px",
     }}
    >
     <span style={{ fontSize: "1.1rem", marginRight: "6px" }}>🎓</span>
     <span style={trackTitle}>
       Student Visa
     </span>
    </div>
    
     <ul style={trackList}>
     <li style={{ display: "list-item" }}>Shortlist the right courses and universities</li>
 <li style={{ display: "list-item" }}>SOP guidance and admission applications that stand out</li>
 <li style={{ display: "list-item" }}>Build a strong visa file with finances and proofs</li>
 <li style={{ display: "list-item" }}>Apply for your visa and get post‑arrival support</li>
    </ul>
   </div>

   {/* Partner of Student Work Visa */}
   <div style={trackCard}>
    <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
     <span style={{ fontSize: "1.3rem", marginRight: "8px" }}>🤝</span>
     <span style={trackTitle}>
       Partner of Student Work Visa
     </span>
    </div>
    <ul style={trackList}>
     <li style={{ display: "list-item" }}>Check eligibility and select the best visa pathway</li>
     <li style={{ display: "list-item" }}>Organise relationship and financial evidence cleanly</li>
     <li style={{ display: "list-item" }}>File a confident, complete work‑visa application</li>
     <li style={{ display: "list-item" }}>Get help settling and finding work in New Zealand</li>
    </ul>
   </div>

   {/* Dependent Visa */}
   <div style={trackCard}>
    <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
     <span style={{ fontSize: "1.3rem", marginRight: "8px" }}>👨‍👩‍👧</span>
     <span style={trackTitle}>
       Dependent Visa
     </span>
    </div>
    <ul style={trackList}>
     <li style={{ display: "list-item" }}>Plan visas for children and dependents seamlessly</li>
     <li style={{ display: "list-item" }}>Get guidance for schools and family settlement</li>
     <li style={{ display: "list-item" }}>Complete all financial proofs</li>
    </ul>
   </div>

   {/* Post‑Study Work Visa */}
   <div style={trackCard}>
    <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
     <span style={{ fontSize: "1.3rem", marginRight: "8px" }}>💼</span>
     <span style={trackTitle}>
       Post‑Study Work Visa
     </span>
    </div>
    <ul style={trackList}>
     <li style={{ display: "list-item" }}>Apply for your open work visa after graduation</li>
     <li style={{ display: "list-item" }}>Get career and job search guidance</li>
     <li style={{ display: "list-item" }}>Plan for PR and Skilled Migrant residency</li>
    </ul>
   </div>
 </div>
</div>

      {/* ── NZ Guide Banner ── */}
      <div
        style={{
          marginTop: "48px",
          borderRadius: "18px",
          background: palette.green,
          border: `1px solid ${palette.gold}`,
          padding: isMobile ? "28px 20px" : "36px 40px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "2px",
              textTransform: "uppercase",
              color: palette.gold,
              marginBottom: "8px",
            }}
          >
            Free Resource
          </div>
          <h3
            style={{
              fontFamily: "'Fira Sans', sans-serif",
              fontSize: isMobile ? "1.15rem" : "1.35rem",
              fontWeight: 900,
              color: palette.white,
              margin: "0 0 8px",
              lineHeight: 1.25,
            }}
          >
            Study in New Zealand from Hyderabad - Complete Guide 2026
          </h3>
          <p
            style={{
              fontSize: "0.9rem",
              color: "rgba(250,248,243,0.75)",
              margin: 0,
              lineHeight: 1.6,
              maxWidth: 480,
            }}
          >
            Universities, visa requirements, costs in rupees, scholarships,
            and post-study work rights - everything in one place.
          </p>
        </div>
        <Link
          to="/study-in-new-zealand-from-hyderabad"
          style={{
            display: "inline-block",
            background: palette.red,
            color: palette.white,
            fontFamily: "'Fira Sans', sans-serif",
            fontWeight: 700,
            fontSize: "0.95rem",
            padding: "12px 28px",
            borderRadius: "10px",
            textDecoration: "none",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          Read the Guide
        </Link>
      </div>

    </Container>
   </ServicesSection>
  );
}

   

function About() {
 const { width: screenWidth } = useWindowSize();
 
 const isMobile = screenWidth < 768;
 const isTablet = screenWidth >= 768 && screenWidth < 1024;

 const creamSoft = "rgba(250, 248, 243, 0.85)";
 
 return (
   <AboutSection>
    <Container>
     <div
       style={{
        maxWidth: "980px",
        margin: "0 auto",
        padding: isMobile ? "20px 16px" : isTablet ? "24px 20px" : "32px 26px", // Responsive padding
        borderRadius: "24px",
        background: palette.white,
        border: `1px solid ${palette.goldBorder}`,
        boxShadow: palette.goldShadow,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", // Responsive: stacks on mobile, 2-col on desktop
        gap: isMobile ? "20px" : "28px",
       }}
     >
       {/* Left: narrative */}
       <div style={{ 
        borderLeft: `3px solid ${palette.gold}`, 
        paddingLeft: isMobile ? "16px" : "20px", marginTop: "1px",
        order: isMobile ? 2 : 1 // Stack stats first on mobile for better flow
       }}>
        <MainSectionTitle style={{ textAlign: "left", marginBottom: "17px" }}>
         About KIWIORA GLOBAL EDUCATION
        </MainSectionTitle>

        <p style={{ 
         fontSize: `clamp(0.95rem, 2.5vw, 1.02rem)`, // Fluid font scaling
         color: palette.text, 
         lineHeight: 1.8, 
         marginBottom: "10px" , 
         textAlign: "left"
        }}>
         <strong>
           KIWIORA is your trusted partner for{" "}
           <span style={{ fontWeight: 800, color: palette.green }}>New Zealand education and migration</span>.
         </strong>{" "}
         We help students and professionals pursue{" "}
         <strong>Bachelors and Masters degrees in New Zealand</strong>,
         guiding them from smart course selection and admissions through to{" "}
         <strong>student visas, post‑study work visas, and long‑term residency pathways</strong>.
        </p>

        <p
         style={{
         fontSize: `clamp(0.9rem, 2.4vw, 0.96rem)`, 
           color: palette.text,
           lineHeight: 1.9,
           marginBottom: "14px", textAlign: "left"
         }}
        >
         Our consultants understand the full New Zealand journey helping
         you <strong>study, work, and settle</strong> with confidence. From
         shortlisting top <strong>New Zealand universities</strong> and
         choosing the right <strong>Bachelors or Masters program</strong> to
         designing a clear <strong>migration and residency plan</strong>, you
         always know what comes next.
        </p>

        <p
         style={{
           fontSize: "0.95rem",
           color: palette.text,
           lineHeight: 1.9,
           marginBottom: "20px",textAlign: "left"
         }}
        >
         At KIWIORA, every profile gets a tailored roadmap covering{" "}
         <strong>study abroad planning</strong>,{" "}
         <strong>education consulting</strong>,{" "}
         <strong>visa strategy</strong>, and{" "}
         <strong>settlement support</strong> so your move to New Zealand
         feels structured, not stressful.
        </p>
       </div>

       {/* Right: compact stats & services block */}
      <div style={{ 
        padding: isMobile ? "14px 14px 12px" : "18px 18px 16px",
        borderRadius: "18px", 
        backgroundColor: palette.green, 
        border: `1px solid ${palette.gold}`,
        color: palette.cream, 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "flex-start", 
           gap: isMobile ? "8px" : "12px",

        order: isMobile ? 2 : 1 // Move to top on mobile
       }}>


       <h3 style={{ fontSize: "0.99rem", textTransform: "uppercase", letterSpacing: "0.12em",
         color: palette.gold,   margin: isMobile ? "4px 0 6px" : "8px 0 10px",
textAlign: "center",}}>
         Why students choose KIWIORA
        </h3>
<div
 style={{
   display: "flex",
   flexDirection: isMobile ? "column" : "row",
   justifyContent: isMobile ? "flex-start" : "space-between",
   alignItems: isMobile ? "flex-start" : "flex-start",
   gap: isMobile ? "8px" : "12px",
 }}
></div>
       {/* 1:1 and End-to-end row */}
<div
 style={{
   display: "flex",
   flexDirection: "row",
   justifyContent: "center",
   alignItems: "flex-start",
   gap: isMobile ? "10px" : "40px",
   textAlign: "center",
 }}
>
 {/* Left: 1:1 */}
 <div style={{ flex: "0 0 auto" }}>
   <p
    style={{
     margin: 0,
     fontSize: isMobile ? "1.1rem" : "1.4rem",
     fontWeight: 800,
     color: palette.gold,
    }}
   >
    1:1
   </p>
   <p
    style={{
     margin: "4px 0 0",
     fontSize: "0.78rem",
     color: creamSoft,
     maxWidth: "130px",
    }}
   >
    Personal strategy from first call to visa grant
   </p>
 </div>

 {/* Right: End‑to‑end */}
 <div style={{ flex: "0 0 auto" }}>
   <p
    style={{
     margin: 0,
     fontSize: "1.1rem",
     fontWeight: 700,
     color: palette.gold,
    }}
   >
    END-TO-END
   </p>
   <p
    style={{
     margin: "4px 0 0",
     fontSize: "0.78rem",
     color: creamSoft,
     maxWidth: "130px",
     marginInline: "auto", // centers text block under heading on desktop
    }}
   >
    Admissions, visas &amp; migration under one roof
   </p>
 </div>
</div>


<hr
 style={{
   border: "none",
   borderTop: "1px solid rgba(184, 134, 11, 0.6)",
   margin: isMobile ? "6px 0" : "8px 0",
 }}
/>

        {/* 3 equal bullet points with even spacing */}
 <ul
 style={{
   margin: 0,
   paddingLeft: isMobile ? "18px" : "22px", // keep some indent so bullets show
   listStyleType: "disc",
   display: "block",
   fontSize: `clamp(0.85rem, 2.2vw, 1.2rem)`,
   color: creamSoft,
   lineHeight: 1,
   marginBottom: "4px",
   textAlign: "center",
 }}
>
 <li style={{ marginTop: "14px" ,marginBottom: "24px" }}>
   Program shortlisting that matches your long‑term plan
 </li>
 <li style={{ marginBottom: "24px" }}>
   Visa files built carefully around New Zealand rules
 </li>
 <li style={{ marginBottom: "14px" }}>
   Support for partners, dependents, and post‑study work
 </li>
</ul>


<hr
 style={{
   border: "none",
   borderTop: "1px solid rgba(184, 134, 11, 0.6)",
   margin: isMobile ? "8px 0 10px" : "10px 0 12px",
 }}
/>

<p
 style={{
   margin: 0,
   fontSize: `clamp(1.0rem, 2.8vw, 1.4rem)`,
   color: palette.cream,
   lineHeight: 1.8,
   textAlign: "center",
 }}
>
 Whether you are just exploring or ready to apply, KIWIORA gives
 you a clear, realistic path to{" "}
 <strong style={{ color: palette.gold }}>study, work, and settle in New Zealand.</strong>
</p>
       </div>
       </div> {/* end of main about card */}

{/* MEET THE FOUNDER */}
<div
  style={{
    maxWidth: "980px",
    margin: "32px auto 0 auto",
    borderRadius: "24px",
    background: palette.white,
    border: `1px solid ${palette.goldBorder}`,
    boxShadow: palette.goldShadow,
    display: "grid",
    gridTemplateColumns: screenWidth < 900 ? "1fr" : "340px 1fr",
    overflow: "hidden",
  }}
>
  {/* LEFT: Photo / brand panel */}
  <div
  style={{
    background: palette.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
  }}
>
     <div
    style={{
      width: "100%",
      height: "100%",
      minHeight: screenWidth < 900 ? 260 : 300,
      position: "relative",
      overflow: "hidden",
    }}
  >
    <img
      src={founderPhoto}
      alt="Sai Kiran Narayan"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>
</div>  

    
  {/* RIGHT: Text content */}
  <div
    style={{
      padding:
        screenWidth < 900 ? "24px 18px 26px" : "32px 32px 32px 28px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      borderLeft: screenWidth < 900 ? "none" : `3px solid ${palette.gold}`,
      borderTop: screenWidth < 900 ? `3px solid ${palette.gold}` : "none",
    }}
  >
    <span
      style={{
        fontSize: "0.8rem",
        fontWeight: 650,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        color: palette.gold,
        marginBottom: 6,
      }}
    >
      Meet the founder
    </span>

    <h3
      style={{
        margin: "0 0 4px",
        fontSize: screenWidth < 900 ? "1.4rem" : "1.6rem",
        fontWeight: 800,
        color: palette.green,
        letterSpacing: "-0.02em",
      }}
    >
      Sai Kiran Narayan
    </h3>

    <p
      style={{
        margin: "0 0 14px",
        fontSize: "0.95rem",
        color: palette.muted,
        fontWeight: 500,
      }}
    >
      Founder &amp; Principal Consultant, KIWIORA
    </p>

    <p
      style={{
        margin: 0,
        maxWidth: 640,
        fontSize: screenWidth < 900 ? "0.9rem" : "0.98rem",
        lineHeight: 1.8,
        color: palette.text,
      }}
    >
     Sai Kiran Narayan is the driving force behind KIWIORA, bringing over <strong style={{ color: palette.gold }}>15 years</strong> of deep expertise in New Zealand education, student visas, and migration pathways. Known for his integrity and unwavering commitment to student success, he has personally guided more than <strong style={{ color: palette.gold }}>10,000</strong> aspirants in shaping their journeys toward studying, working, and settling in New Zealand.
<br />
<br />His journey began with a simple belief: <strong>the right guidance can transform a student’s life.</strong>
<br />
<br />With extensive hands-on experience in New Zealand’s visa requirements, university requirements, and residency pathways, he combines strategic visa planning with a deep understanding of what students and families truly need.
<br />
<br />At KIWIORA, his mission is clear and consistent:
to make world-class New Zealand education and migration opportunities accessible, transparent, and stress-free for every aspirant.
    </p>
  </div>
</div>



      </Container>

{/* GOOGLE REVIEWS (IMAGE BASED) */}
<ReviewsSection>
  <SectionHeader>
    <h2>Customer Reviews</h2>
  </SectionHeader>
  
  <div style={{
    display: 'flex',
    justifyContent: reviewImages.length === 1 ? 'center' : 'flex-start',
    padding: '1rem 0.25rem',
    width: '100%',
    overflow: reviewImages.length === 1 ? 'visible' : 'auto',  // Scroll only when multiple
    gap: '0.5rem'
  }}>
    {reviewImages.map((img, index) => (
      <div 
        key={index}
        style={{
          width: screenWidth >= 769 ? '600px' : '300px',  // DESKTOP 600px, MOBILE 300px
          maxWidth: 'calc(100vw - 1rem)',
          height: 'auto',
          borderRadius: '12px',
          overflow: 'hidden',
          flexShrink: 0,
          background: palette.white,
          border: `1px solid ${palette.goldBorder}`,
          boxShadow: palette.goldShadow,
        }}
      >
        <img 
          src={img} 
          alt={`Google Review ${index + 1}`}
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: '12px',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>
    ))}
  </div>
</ReviewsSection>

    </AboutSection>

 );
    
}




const ReviewsTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 900;
  color: ${palette.green};
  margin-bottom: 16px;
  letter-spacing: -0.02em;
`;

const ReviewsSubtitle = styled.p`
  font-size: 1.15rem;
  color: ${palette.muted};
  max-width: 600px;
  margin: 0 auto 48px;
`;

const ReviewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 28px;
  max-width: 1000px;
  margin: 0 auto;
`;

// --- START OF REVIEW DATA ---
const reviewsData = [

  {
   
    img: review3, // Using your imported image
 
  }
];
// --- END OF REVIEW DATA ---


// ABOUT US section ends here 

function FAQ() {
 const faqItems = [
   {
    question: "What services does KIWIORA provide?",
    answer:
     "KIWIORA offers complete support for New Zealand Bachelors/Masters admissions, student visas, post-study work visas, partner and dependent visas, and long-term migration and residency planning.",
   },
   {
    question: "Am I eligible to study Bachelors or Masters in New Zealand?",
    answer:
     "Eligibility depends on your academic background (12th grade for Bachelors, an undergraduate degree for Masters) and English language tests such as IELTS, PTE, or TOEFL. We help assess your profile and guide you to suitable programs.",
   },
   {
    question: "What is your success rate?", 
    answer:
     "We have a 95% client satisfaction rate and thousands of successful visa applications over 15 years.",
   },
   {
    question: "What is the average tuition fee to study in New Zealand?",
 answer:
 "Average tuition fees for international students in New Zealand range from NZD 20,000 to NZD 40,000+."
   },

   {
    question: "Apart from the tuition fee, do I need to show any additional funds?",
 answer:
 "Yes, apart from the tuition fee, international students need to demonstrate their living expenses under the Funds Transfer Scheme (FTS) and cover the outward travel fee."
   },

 
 {
  question: "What is green list occupation in New Zealand?",
  answer: (
    <div>
      New Zealand's Green List is a register of high-demand, skilled occupations where the country faces notable shortages, providing migrants with quicker routes to residency. It has two levels: Tier 1 jobs (such as some engineers, construction managers, healthcare roles) that offer a 'Straight to Residence' visa for immediate permanent residency with a job offer, and Tier 2 jobs (such as some construction trades, primary teachers after March 2025) that offer a 'Work to Residence' pathway after two years of employment. The list aims to attract essential overseas workers to fill critical skill gaps.
      
      <p>
        <a 
          href="https://www.immigration.govt.nz/work/requirements-for-work-visas/green-list-occupations-qualifications-and-skills/green-list-roles-jobs-we-need-people-for-in-new-zealand/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: palette.green, fontWeight: 600, textDecoration: 'underline', textDecorationColor: palette.gold }}
        >
          Green List roles - jobs we need people for in New Zealand
        </a>
      </p>
    </div>
  ),
}
,
];

 const [expandedIndex, setExpandedIndex] = React.useState(null);

 function toggle(index) {
   setExpandedIndex(expandedIndex === index ? null : index);
 }

 return (
   <FAQSection>
    <Container>
     <MainSectionTitle >People Frequently Asked <span>Few Questions</span></MainSectionTitle >
        <FAQListWrapper>
     {faqItems.map((item, idx) => (
       <FAQItem key={idx}>
        <FAQQuestion
         aria-expanded={expandedIndex === idx}
         aria-controls={`faq${idx}`}
         id={`faqq${idx}`}
         onClick={() => toggle(idx)}
        >
         {item.question}
         <span>{expandedIndex === idx ? "−" : "+"}</span>
        </FAQQuestion>
        <FAQAnswer id={`faq${idx}`} role="region" aria-labelledby={`faqq${idx}`} expanded={expandedIndex === idx}>
         {item.answer}
        </FAQAnswer>
       </FAQItem>
     ))}
        </FAQListWrapper>
    </Container>
   </FAQSection>
 );
}

function SuccessStories() {
   const location = useLocation();
const [refreshKey, setRefreshKey] = React.useState(0);

React.useEffect(() => {
 // Increment refreshKey each time the route changes to force remount
 setRefreshKey((prev) => prev + 1);
}, [location]);

 const stats = [
   { icon: "users", value: "3,369+", label: "Success Stories" },
   { icon: "target", value: "98.7%", label: "Success Rate" },
   { icon: "location", value: "9+", label: "Countries" },
   { icon: "trend", value: "100%", label: "Client Satisfaction" }
 ];

 const testimonials = [
   {
    name: "Arjun Reddy",
    location: "Hyderabad → NZ",
    visaType: "Student Visa",
    year: "2023",
    stars: 5,
    image: "AR",
    story: "KIWIORA made my dream of studying in Australia come true. Their guidance through the entire process was exceptional, from university selection to visa approval. The team was always available to answer my questions and provided valuable insights that helped me secure admission to my preferred university.",
    outcome: "Masters in Computer Science at University of Melbourne",
    timeline: "4 months",
    highlights: ["University Selection", "Scholarship Guidance", "Visa Success"]
   },
   {
    name: "Preethi Nair",
    location: "Kerala → NZ", 
    visaType: "Work Visa",
    year: "2023",
    stars: 5,
    image: "PN",
    story: "The expertise and professionalism of KIWIORA team exceeded my expectations. They helped me navigate the complex Canadian immigration system and secured my work permit faster than I anticipated. Their attention to detail and personalised service made all the difference.",
    outcome: "Senior Software Engineer at Tech Company",
    timeline: "6 months",
    highlights: ["Job Placement", "Work Permit", "Family Visa"]
   },
   {
    name: "David & Sarah Williams",
    location: "Mumbai → NZ",
    visaType: "Family Visa",
    year: "2022",
    stars: 5,
    image: "DW",
    story: "Relocating our entire family seemed overwhelming until we found KIWIORA. Their comprehensive support covered every aspect - from documents to settling in New Zealand. The team's genuine care and expert guidance made our education journey smooth and stress-free.",
    outcome: "Permanent Residence in New Zealand",
    timeline: "8 months",
    highlights: ["Family Migration", "Permanent Residence", "Settlement Support"]
   },
   {
    name: "Rahul Sharma",
    location: "Delhi → NZ",
    visaType: "Business Visa",
    year: "2023",
    stars: 5,
    image: "RS",
    story: "KIWIORA's business visa expertise helped me establish my UK operations seamlessly. Their understanding of business immigration requirements and strategic approach ensured quick approval. They're not just consultants, they're partners in your success.",
    outcome: "Successful Business Expansion to UK",
    timeline: "3 months",
    highlights: ["Business Setup", "Investor Visa", "Legal Compliance"]
   }
 ];

 const categories = [
   { name: "All Stories", count: "3,369+" },
   { name: "Student Visas", count: "2,150+" },
   { name: "Work Visas", count: "1,890+" },
   { name: "Family Visas", count: "980+" },
   { name: "Business Visas", count: "349+" }
 ];

 return (
<successContainer key={refreshKey} style={{ background: LightBg, paddingTop: "32px", paddingBottom: "64px" }}>
    {/* Hero Section */}
    <SectionTitle style={{ fontSize: "2.7rem", textAlign: "center", letterSpacing: "0.02em", fontWeight: 900, color: BrandGreen }}>
     Real Stories, <span style={{ color: AccentGold }}>Real Success</span>
    </SectionTitle>
    <p style={{textAlign:"center",color:palette.muted,fontSize:"1.22rem",margin:"12px 0 32px 0"}}>
     Discover how KIWIORA has transformed thousands of lives through successful education journeys. These are the stories of our clients who trusted us with their dreams and achieved their global aspirations.
    </p>
    
    {/* Stats Section */}
    <StatsGridsuccess>
     {stats.map((stat, idx) => (
       <StatCardsuccess key={idx}>
        <div style={{ marginBottom: '12px' }}>
         <StatIcon name={stat.icon} />
        </div>
        <StatNumber>{stat.value}</StatNumber>
        <StatLabel>{stat.label}</StatLabel>
       </StatCardsuccess>
     ))}
    </StatsGridsuccess>
    
    {/* Categories Filter */}
    <CategoriesBar>
     {categories.map((c, idx) => (
       <CategoryBtn key={idx} active={idx === 0}>
        {c.name} ({c.count})
       </CategoryBtn>
     ))}
    </CategoriesBar>
    
    {/* Testimonials Grid */}
    <TestimonialGrid>
     {testimonials.map((t, idx) => (
       <TestimonialCard key={idx}>
        <TestHeader>
         <TestMeta>
           <AvatarCircle>{t.image}</AvatarCircle>
           <TestInfo>
            <TestName>{t.name}</TestName>
            <TestLocation>{t.location}</TestLocation>
           </TestInfo>
         </TestMeta>
         <div>
           <Badge>{t.visaType}</Badge>
           <Badge bg>{t.year}</Badge>
         </div>
        </TestHeader>
        <Stars>
         {[...Array(t.stars)].map((_, i) => (
           <svg key={i} width="22" height="22" fill={staryellow} style={{marginRight:2}} viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568L24 9.423l-6 6.157 1.416 7.684L12 18.896l-7.416 4.368L6 15.58l-6-6.157 8.332-1.268z"/></svg>
         ))}
        </Stars>
        <StoryText>{t.story}</StoryText>
        <OutcomeBox>Outcome: {t.outcome}</OutcomeBox>
        <TimelineRow>
         <svg width="20" height="20" fill={AccentGold} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke={AccentGold} strokeWidth="2" fill="#fff"/><path d="M12 7v5l4 2" stroke={AccentGold} strokeWidth="2" fill="none"/></svg>
         <span>Timeline: {t.timeline}</span>
        </TimelineRow>
        <HighlightsBar>
         {t.highlights.map((h, i) => (
           <HighlightTag key={i}>{h}</HighlightTag>
         ))}
        </HighlightsBar>
       </TestimonialCard>
     ))}
    </TestimonialGrid>
    
    <LoadMoreBtn>Load More Success Stories</LoadMoreBtn>
    
    <CTASection>
     <SectionTitle style={{ fontSize: "2.1rem", color:"#fff", marginBottom: "18px" }}>
       Your Success Story Starts Here
     </SectionTitle>
     <p style={{ color: palette.cream, fontSize: "1.19rem", maxWidth: 560, margin: "0 auto 32px" }}>
       Join thousands of satisfied clients who have achieved their education dreams with KIWIORA. Let us help you write your own success story.
     </p>
     <CTAButtons>
       <CTAButton primary href="#/appointment">Start Your Journey</CTAButton>
       <CTAButton href="#/services">View All Services</CTAButton>
     </CTAButtons>
    </CTASection>
   </successContainer>
 );
}

function Footer() {
 return (
   <FooterWrapper>
    <p className="footer-contact">
 Contact us: <a href="tel:+919849995490" style={{color: palette.gold, fontWeight: 600}}>+91 98499 95490</a>
 <span className="footer-contact-divider"> | </span>
 <br className="footer-contact-mobile-break"/>
 Email: <a href="mailto:info@kiwiora.in" style={{color: palette.gold, fontWeight: 600}}>info@kiwiora.in</a>
</p>

    <FooterSocial>
     <FooterLink href="https://wa.me/919849995490" target="_blank" rel="noopener noreferrer">
       <FaWhatsapp /> WhatsApp
     </FooterLink>
     <FooterLink href="https://www.facebook.com/profile.php?id=61584757966366#" target="_blank" rel="noopener noreferrer">
       <FaFacebookF /> Facebook
     </FooterLink>
     <FooterLink href="https://instagram.com/KIWIORA.in" target="_blank" rel="noopener noreferrer">
       <FaInstagram /> Instagram
     </FooterLink>
     {/* <FooterLink href="https://twitter.com/KIWIORA" target="_blank" rel="noopener noreferrer">
       <FaTwitter /> Twitter
     </FooterLink> */}
    </FooterSocial>
    <p style={{fontSize:'0.97rem',margin:'6px 0 0 0', color: 'rgba(250,248,243,0.8)'}}>©  KIWIORA GLOBAL EDUCATION. All rights reserved.</p> 
   </FooterWrapper>
 );
}
//{new Date().getFullYear()}

// Page placeholders for routing


function Help() {
 const helpLink = { color: palette.green, fontWeight: 600, textDecoration: 'underline', textDecorationColor: palette.gold };
 const helpHeading = { fontSize: '1.4rem', fontWeight: 700, marginBottom: '16px', color: palette.green };

 return (
   <Container 
   className="help-container"
   style={{ paddingTop: "48px", paddingBottom: "48px", maxWidth: '740px', margin: '0 auto', color: palette.text, fontFamily: 'Fira Sans, Segoe UI, Arial, sans-serif' }}>
    <MainSectionTitle 
    className="help-title"
    style={{ fontSize: '2rem', fontWeight: 800, color: palette.green, marginBottom: '12px', textAlign: 'left' }}>
     Welcome to the KIWIORA Help Center
    </MainSectionTitle >
    <p 
    className="help-subtitle"
    style={{ fontSize: '1.15rem', color: palette.muted, marginBottom: '40px', textAlign: 'left' }}>
     Find answers, get support, and prepare for your  Study-Abroad journey.
    </p>

    <h3 style={helpHeading}>Frequently Asked Questions</h3>


     <p><strong>Q: What services does KIWIORA provide?</strong> 
     <br /> KIWIORA offers complete support for New Zealand Bachelors/Masters admissions, student visas, post-study work visas, partner and dependent visas, and long-term migration and residency planning.</p>
<p><strong>Q: Am I eligible to study Bachelors or Masters in New Zealand?</strong>
 <br />Eligibility depends on your academic background (12th grade for Bachelors, an undergraduate degree for Masters) and English language tests such as IELTS, PTE, or TOEFL. We help assess your profile and guide you to suitable programs.</p>
<p><strong>Q: How does KIWIORA help with university admissions?</strong>
 <br />We assist with program shortlisting, scholarships, and application submission for both undergraduate and postgraduate programs.</p>
<p><strong>Q: Does KIWIORA help with New Zealand visa applications?</strong> 
<br />Yes. We handle Student Visas, Partner of Student Work Visas, Dependent Visas, and Post-Study Work Visas guiding you through finances and sponsorships.</p>
<p><strong>Q: Can studying in New Zealand lead to work and residency?</strong> 
<br />Absolutely. Completing an eligible Bachelors or Masters degree can lead to a Post-Study Work Visa, skilled employment, and clear pathways to New Zealand residency and PR as per INZ guidelines.</p>
<>
  <p>
    <strong>Q: Can I take my partner with me while studying in New Zealand?</strong> <br />
    Yes. Depending on your course and visa type, your partner may be eligible for a Partner of Student Work Visa, which allows them to live and often work in New Zealand. KIWIORA provides full support with relationship proofs, and the visa application.
  </p>
  <p>
    <a 
      href="https://www.immigration.govt.nz/study/once-you-have-a-student-visa/working-on-a-student-visa/" 
      target="_blank" 
      rel="noopener noreferrer" 
      style={helpLink}
    >
      Learn more about Part-Time Work Rights
    </a>
  </p>

  <p>
    <strong>Q: Can I work while studying in New Zealand?</strong> <br />
    Most full-time international students can work up to 25 hours per week during semesters and full-time during academic breaks. We guide you on job search and compliance requirements.
  </p>
  <p>
    <a 
      href="https://www.immigration.govt.nz/visas/partner-of-a-student-work-visa/" 
      target="_blank" 
      rel="noopener noreferrer" 
      style={helpLink}
    >
      Learn more about Partner of a Student Work Visa
    </a>
  </p>
</>

<p><strong>Q: How long does the New Zealand student visa process take?</strong> 
<br />Processing generally takes 4–8 weeks, depending on documentation and peak seasons. We help you prepare a complete, error-free application for faster outcomes.</p>
<p><strong>Q: What post-arrival support does KIWIORA provide?</strong>
<br /> We assist with accommodation search, onboarding, basic settlement guidance, and connecting you to university services to make your arrival in New Zealand smooth and stress-free.</p>
<p><strong>Q: Why choose KIWIORA over other consultancies?</strong>
<br /> KIWIORA offers free, transparent, and personalised guidance for studying and migrating to New Zealand. We provide end-to-end support from program selection and admissions to visas, work pathways, and residency planning ensuring a smooth journey to study, work, and settle in New Zealand.</p>

   <h3 style={helpHeading}>Contact Support</h3>

   <p>Phone: +91 98499 95490 </p>
   <p>Email: <a href="mailto:info@kiwiora.in" style={helpLink}>info@kiwiora.in</a></p>
   <p>WhatsApp: <a href="https://wa.me/919849995490" target="_blank" rel="noopener noreferrer" style={helpLink}>Chat with us instantly</a></p>
   <p>Office Location: Hyderabad, India</p>
{/* //important resources removed */}
   {/* <h3 style={helpHeading}>Important Resources</h3> */}

   <ul style={{ marginLeft: '18px', marginBottom: '30px', fontSize: '1.02rem' }}>
   {/* <li><a href="#" style={helpLink}>Visa Application Checklist (PDF)</a></li> */}
   {/* <li><a href="#" style={helpLink}>New Zealand Immigration Guide (PDF)</a></li> */}
   {/* <li><a href="#" style={helpLink}>Student Visa Requirements (PDF)</a></li> */}
   </ul>

   <h3 style={helpHeading}>Book a Consultation</h3>

   <p>Ready to get personalised advice? </p>
   <p style= {{ marginTop: '0px'}}>Our consultants look forward to guiding you on your Study-Abroad journey!</p>

   {/* <a href="#/appointment" 
      className="help-cta"

      style={{
   display: 'inline-block',
   fontWeight: 700,
   backgroundColor: palette.red,
   color: palette.white,
   fontSize: '1rem',
   padding: '14px 34px',
   borderRadius: '12px',
   textAlign: 'center',
   margin: '20px auto 0 auto',
   cursor: 'pointer',
   textDecoration: 'none',
   boxShadow: '0 4px 14px rgba(192, 57, 43, 0.25)',
   transition: 'background 0.2s ease'
   }}
   onClick={e => {
  e.preventDefault();
  window.location.hash = "/appointment"; // or use your router navigate
  window.scrollTo({ top: 0, behavior: "smooth" });
 }}
>
   Book Your Appointment Now
   </a> */}
  </Container>
 );
}

function Contact() {
 return (
  <Container style={{ paddingTop: "48px", paddingBottom: "48px" }}>
   <MainSectionTitle >Multiple Ways to Connect</MainSectionTitle >
<section>
 <p style={{textAlign:'center',color: palette.muted,fontSize:'1.08rem',marginBottom:'8px'}}>
  Choose your preferred method to get in touch with our experts.
 </p>
 <ContactGrid>
   <ContactCard href="tel:+919849995490">
   <IconCircle>
   <FaPhoneAlt />
   </IconCircle>
   <CardHeading>Call Us</CardHeading>
   <CardSub>+91 98499 95490</CardSub>
   {/* <CardDesc>Mon–Sat: 9AM to 6PM</CardDesc> */}
   <CardButton>Call Now</CardButton>
  </ContactCard>

  <ContactCard href="mailto:info@kiwiora.in">
   <IconCircle>
   <FaEnvelope />
   </IconCircle>
   <CardHeading>Email Us</CardHeading>
   <CardSub>info@kiwiora.in</CardSub>
   {/* <CardDesc>Quick response within 24H</CardDesc> */}
   <CardButton>Send Email</CardButton>
  </ContactCard>

  <ContactCard href="https://wa.me/919849995490" target="_blank" rel="noopener">
   <IconCircle>
   <FaWhatsapp />
   </IconCircle>
   <CardHeading>WhatsApp</CardHeading>
   <CardSub>+91 98499 95490</CardSub>
   {/* <CardDesc>Instant messaging support</CardDesc> */}
   <CardButton>Chat Now</CardButton>
  </ContactCard>
 
  <ContactCard href="https://www.google.com/maps/place/+Hyderabad" target="_blank" rel="noopener">
   <IconCircle>
   <FaMapMarkerAlt />
   </IconCircle>
   <CardHeading>Book a 1:1 session</CardHeading>
   <CardSub>Hyderabad, India</CardSub>
   <CardDesc>Contact us for more details</CardDesc>
   {/* <CardButton>Get Directions</CardButton> */}
  </ContactCard>
</ContactGrid>

</section>

  </Container>
 );
}
const countries = [
 { code: "AF", dial_code: "+93", name: "Afghanistan", flag: "🇦🇫" },
 { code: "AL", dial_code: "+355", name: "Albania", flag: "🇦🇱" },
 { code: "DZ", dial_code: "+213", name: "Algeria", flag: "🇩🇿" },
 { code: "AS", dial_code: "+1684", name: "American Samoa", flag: "🇦🇸" },
 { code: "AD", dial_code: "+376", name: "Andorra", flag: "🇦🇩" },
 { code: "AO", dial_code: "+244", name: "Angola", flag: "🇦🇴" },
 { code: "AI", dial_code: "+1264", name: "Anguilla", flag: "🇦🇮" },
 { code: "AG", dial_code: "+1268", name: "Antigua and Barbuda", flag: "🇦🇬" },
 { code: "AR", dial_code: "+54", name: "Argentina", flag: "🇦🇷" },
 { code: "AM", dial_code: "+374", name: "Armenia", flag: "🇦🇲" },
 { code: "AW", dial_code: "+297", name: "Aruba", flag: "🇦🇼" },
 { code: "AU", dial_code: "+61", name: "Australia", flag: "🇦🇺" },
 { code: "AT", dial_code: "+43", name: "Austria", flag: "🇦🇹" },
 { code: "AZ", dial_code: "+994", name: "Azerbaijan", flag: "🇦🇿" },
 { code: "BS", dial_code: "+1242", name: "Bahamas", flag: "🇧🇸" },
 { code: "BH", dial_code: "+973", name: "Bahrain", flag: "🇧🇭" },
 { code: "BD", dial_code: "+880", name: "Bangladesh", flag: "🇧🇩" },
 { code: "BB", dial_code: "+1246", name: "Barbados", flag: "🇧🇧" },
 { code: "BY", dial_code: "+375", name: "Belarus", flag: "🇧🇾" },
 { code: "BE", dial_code: "+32", name: "Belgium", flag: "🇧🇪" },
 { code: "BZ", dial_code: "+501", name: "Belize", flag: "🇧🇿" },
 { code: "BJ", dial_code: "+229", name: "Benin", flag: "🇧🇯" },
 { code: "BM", dial_code: "+1441", name: "Bermuda", flag: "🇧🇲" },
 { code: "BT", dial_code: "+975", name: "Bhutan", flag: "🇧🇹" },
 { code: "BO", dial_code: "+591", name: "Bolivia", flag: "🇧🇴" },
 { code: "BA", dial_code: "+387", name: "Bosnia and Herzegovina", flag: "🇧🇦" },
 { code: "BW", dial_code: "+267", name: "Botswana", flag: "🇧🇼" },
 { code: "BR", dial_code: "+55", name: "Brazil", flag: "🇧🇷" },
 { code: "BN", dial_code: "+673", name: "Brunei", flag: "🇧🇳" },
 { code: "BG", dial_code: "+359", name: "Bulgaria", flag: "🇧🇬" },
 { code: "BF", dial_code: "+226", name: "Burkina Faso", flag: "🇧🇫" },
 { code: "BI", dial_code: "+257", name: "Burundi", flag: "🇧🇮" },
 { code: "KH", dial_code: "+855", name: "Cambodia", flag: "🇰🇭" },
 { code: "CM", dial_code: "+237", name: "Cameroon", flag: "🇨🇲" },
 { code: "CA", dial_code: "+1", name: "Canada", flag: "🇨🇦" },
 { code: "CV", dial_code: "+238", name: "Cape Verde", flag: "🇨🇻" },
 { code: "KY", dial_code: "+1345", name: "Cayman Islands", flag: "🇰🇾" },
 { code: "CF", dial_code: "+236", name: "Central African Republic", flag: "🇨🇫" },
 { code: "TD", dial_code: "+235", name: "Chad", flag: "🇹🇩" },
 { code: "CL", dial_code: "+56", name: "Chile", flag: "🇨🇱" },
 { code: "CN", dial_code: "+86", name: "China", flag: "🇨🇳" },
 { code: "CO", dial_code: "+57", name: "Colombia", flag: "🇨🇴" },
 { code: "KM", dial_code: "+269", name: "Comoros", flag: "🇰🇲" },
 { code: "CR", dial_code: "+506", name: "Costa Rica", flag: "🇨🇷" },
 { code: "HR", dial_code: "+385", name: "Croatia", flag: "🇭🇷" },
 { code: "CU", dial_code: "+53", name: "Cuba", flag: "🇨🇺" },
 { code: "CY", dial_code: "+357", name: "Cyprus", flag: "🇨🇾" },
 { code: "CZ", dial_code: "+420", name: "Czech Republic", flag: "🇨🇿" },
 { code: "DK", dial_code: "+45", name: "Denmark", flag: "🇩🇰" },
 { code: "DJ", dial_code: "+253", name: "Djibouti", flag: "🇩🇯" },
 { code: "DM", dial_code: "+1767", name: "Dominica", flag: "🇩🇲" },
 { code: "DO", dial_code: "+1", name: "Dominican Republic", flag: "🇩🇴" },
 { code: "EC", dial_code: "+593", name: "Ecuador", flag: "🇪🇨" },
 { code: "EG", dial_code: "+20", name: "Egypt", flag: "🇪🇬" },
 { code: "SV", dial_code: "+503", name: "El Salvador", flag: "🇸🇻" },
 { code: "EE", dial_code: "+372", name: "Estonia", flag: "🇪🇪" },
 { code: "ET", dial_code: "+251", name: "Ethiopia", flag: "🇪🇹" },
 { code: "FI", dial_code: "+358", name: "Finland", flag: "🇫🇮" },
 { code: "FR", dial_code: "+33", name: "France", flag: "🇫🇷" },
 { code: "GA", dial_code: "+241", name: "Gabon", flag: "🇬🇦" },
 { code: "GM", dial_code: "+220", name: "Gambia", flag: "🇬🇲" },
 { code: "GE", dial_code: "+995", name: "Georgia", flag: "🇬🇪" },
 { code: "DE", dial_code: "+49", name: "Germany", flag: "🇩🇪" },
 { code: "GH", dial_code: "+233", name: "Ghana", flag: "🇬🇭" },
 { code: "GR", dial_code: "+30", name: "Greece", flag: "🇬🇷" },
 { code: "GT", dial_code: "+502", name: "Guatemala", flag: "🇬🇹" },
 { code: "HN", dial_code: "+504", name: "Honduras", flag: "🇭🇳" },
 { code: "HK", dial_code: "+852", name: "Hong Kong", flag: "🇭🇰" },
 { code: "HU", dial_code: "+36", name: "Hungary", flag: "🇭🇺" },
 { code: "IS", dial_code: "+354", name: "Iceland", flag: "🇮🇸" },
 { code: "IN", dial_code: "+91", name: "India", flag: "🇮🇳" },
 { code: "ID", dial_code: "+62", name: "Indonesia", flag: "🇮🇩" },
 { code: "IR", dial_code: "+98", name: "Iran", flag: "🇮🇷" },
 { code: "IQ", dial_code: "+964", name: "Iraq", flag: "🇮🇶" },
 { code: "IE", dial_code: "+353", name: "Ireland", flag: "🇮🇪" },
 { code: "IL", dial_code: "+972", name: "Israel", flag: "🇮🇱" },
 { code: "IT", dial_code: "+39", name: "Italy", flag: "🇮🇹" },
 { code: "JM", dial_code: "+1876", name: "Jamaica", flag: "🇯🇲" },
 { code: "JP", dial_code: "+81", name: "Japan", flag: "🇯🇵" },
 { code: "JO", dial_code: "+962", name: "Jordan", flag: "🇯🇴" },
 { code: "KZ", dial_code: "+7", name: "Kazakhstan", flag: "🇰🇿" },
 { code: "KE", dial_code: "+254", name: "Kenya", flag: "🇰🇪" },
 { code: "KR", dial_code: "+82", name: "South Korea", flag: "🇰🇷" },
 { code: "KW", dial_code: "+965", name: "Kuwait", flag: "🇰🇼" },
 { code: "LV", dial_code: "+371", name: "Latvia", flag: "🇱🇻" },
 { code: "LB", dial_code: "+961", name: "Lebanon", flag: "🇱🇧" },
 { code: "LT", dial_code: "+370", name: "Lithuania", flag: "🇱🇹" },
 { code: "LU", dial_code: "+352", name: "Luxembourg", flag: "🇱🇺" },
 { code: "MY", dial_code: "+60", name: "Malaysia", flag: "🇲🇾" },
 { code: "MV", dial_code: "+960", name: "Maldives", flag: "🇲🇻" },
 { code: "MT", dial_code: "+356", name: "Malta", flag: "🇲🇹" },
 { code: "MX", dial_code: "+52", name: "Mexico", flag: "🇲🇽" },
 { code: "MN", dial_code: "+976", name: "Mongolia", flag: "🇲🇳" },
 { code: "MA", dial_code: "+212", name: "Morocco", flag: "🇲🇦" },
 { code: "MM", dial_code: "+95", name: "Myanmar", flag: "🇲🇲" },
 { code: "NP", dial_code: "+977", name: "Nepal", flag: "🇳🇵" },
 { code: "NL", dial_code: "+31", name: "Netherlands", flag: "🇳🇱" },
 { code: "NZ", dial_code: "+64", name: "New Zealand", flag: "🇳🇿" },
 { code: "NG", dial_code: "+234", name: "Nigeria", flag: "🇳🇬" },
 { code: "NO", dial_code: "+47", name: "Norway", flag: "🇳🇴" },
 { code: "PK", dial_code: "+92", name: "Pakistan", flag: "🇵🇰" },
 { code: "PS", dial_code: "+970", name: "Palestine", flag: "🇵🇸" },
 { code: "PE", dial_code: "+51", name: "Peru", flag: "🇵🇪" },
 { code: "PH", dial_code: "+63", name: "Philippines", flag: "🇵🇭" },
 { code: "PL", dial_code: "+48", name: "Poland", flag: "🇵🇱" },
 { code: "PT", dial_code: "+351", name: "Portugal", flag: "🇵🇹" },
 { code: "QA", dial_code: "+974", name: "Qatar", flag: "🇶🇦" },
 { code: "RO", dial_code: "+40", name: "Romania", flag: "🇷🇴" },
 { code: "RU", dial_code: "+7", name: "Russia", flag: "🇷🇺" },
 { code: "SA", dial_code: "+966", name: "Saudi Arabia", flag: "🇸🇦" },
 { code: "RS", dial_code: "+381", name: "Serbia", flag: "🇷🇸" },
 { code: "SG", dial_code: "+65", name: "Singapore", flag: "🇸🇬" },
 { code: "SK", dial_code: "+421", name: "Slovakia", flag: "🇸🇰" },
 { code: "SI", dial_code: "+386", name: "Slovenia", flag: "🇸🇮" },
 { code: "ZA", dial_code: "+27", name: "South Africa", flag: "🇿🇦" },
 { code: "ES", dial_code: "+34", name: "Spain", flag: "🇪🇸" },
 { code: "LK", dial_code: "+94", name: "Sri Lanka", flag: "🇱🇰" },
 { code: "SE", dial_code: "+46", name: "Sweden", flag: "🇸🇪" },
 { code: "CH", dial_code: "+41", name: "Switzerland", flag: "🇨🇭" },
 { code: "SY", dial_code: "+963", name: "Syria", flag: "🇸🇾" },
 { code: "TW", dial_code: "+886", name: "Taiwan", flag: "🇹🇼" },
 { code: "TH", dial_code: "+66", name: "Thailand", flag: "🇹🇭" },
 { code: "TL", dial_code: "+670", name: "Timor-Leste", flag: "🇹🇱" },
 { code: "TR", dial_code: "+90", name: "Turkey", flag: "🇹🇷" },
 { code: "UA", dial_code: "+380", name: "Ukraine", flag: "🇺🇦" },
 { code: "AE", dial_code: "+971", name: "United Arab Emirates", flag: "🇦🇪" },
 { code: "GB", dial_code: "+44", name: "United Kingdom", flag: "🇬🇧" },
 { code: "US", dial_code: "+1", name: "United States", flag: "🇺🇸" },
 { code: "UY", dial_code: "+598", name: "Uruguay", flag: "🇺🇾" },
 { code: "VE", dial_code: "+58", name: "Venezuela", flag: "🇻🇪" },
 { code: "VN", dial_code: "+84", name: "Vietnam", flag: "🇻🇳" },
 { code: "YE", dial_code: "+967", name: "Yemen", flag: "🇾🇪" },
 { code: "ZM", dial_code: "+260", name: "Zambia", flag: "🇿🇲" },
 { code: "ZW", dial_code: "+263", name: "Zimbabwe", flag: "🇿🇼" }
];


const CountryCodeSelect = ({ value, onChange }) => {
 const [open, setOpen] = useState(false);

 const selectedCountry =
  countries.find((c) => c.dial_code === value) || null;

const handleSelect = (c) => {
 onChange(c.dial_code); // just pass the value up
 setOpen(false);
};

 return (
  <div style={{ position: "relative" }}>
   {/* Trigger */}
   <button
   type="button"
   onClick={() => setOpen(!open)}
   style={{
     width: "100%",
     padding: "10px 14px",
     border: `2px solid ${palette.goldBorder}`,
     borderRadius: "8px",
     background: palette.white,
     color: palette.text,
     textAlign: "left",
     cursor: "pointer"
   }}
   >
   {selectedCountry
     ? `${selectedCountry.flag} ${selectedCountry.name} ${selectedCountry.dial_code}`
     : "Select Country"}
   </button>

   {/* Dropdown list */}
   {open && (
   <div
     style={{
     position: "absolute",
     zIndex: 20,
     top: "110%",
     left: 0,
     right: 0,
     maxHeight: "250px",
     overflowY: "auto",
     background: palette.white,
     border: `1px solid ${palette.goldBorder}`,
     borderRadius: "8px",
     boxShadow: "0 4px 10px rgba(0,0,0,0.12)"
     }}
   >
     {countries.map((c) => (
     <div
      key={c.code}
      onClick={() => handleSelect(c)}
      style={{
       padding: "8px 12px",
       display: "flex",
       alignItems: "center",
       gap: "8px",
       cursor: "pointer",
       fontSize: "14px",
       color: palette.text
      }}
     >
      <span style={{ fontSize: "18px" }}>{c.flag}</span>
      <span>{c.name}</span>
      <span style={{ marginLeft: "auto", color: palette.muted }}>
       {c.dial_code}
      </span>
     </div>
     ))}
   </div>
   )}
  </div>
 );
};



// function Appointment() {
//  const [countryCode, setCountryCode] = React.useState("");

// const handleSubmit = async (e) => {
// e.preventDefault(); // stop normal form submit


// const formData = {
// email: e.target.email.value,
// firstName: e.target.firstName.value,
// lastName: e.target.lastName.value,
// // countryCode: e.target.countryCode.value,
// countryCode: countryCode, // use state

// phone: e.target.phone.value,
// // currentCountry: e.target.currentCountry.value,
// // nationality: e.target.nationality.value,
// visaType: e.target.visaType.value,
// message: e.target.message.value,
// };

// try {
// await fetch('https://script.google.com/macros/s/AKfycbyCqj6cf-gp6AZccdG175TTchq2J9OsBZ0l7QK-cpX-VmJBmAL_OxZRmkJaUge2olYQaw/exec', {
//  method: 'POST',
//  mode: 'no-cors',
//  headers: {
//   'Content-Type': 'application/json',
//  },
//  body: JSON.stringify(formData),
// });

// alert('Message sent! Our team will contact you soon.');
// e.target.reset();
// } catch (err) {
// alert('Could not send. Please try again later.');
// console.error(err);
// }
// };

/* Fix react-phone-input-2 country dropdown to be vertical */



function Appointment() {
 const [countryCode, setCountryCode] = React.useState("");
 const [isSubmitting, setIsSubmitting] = React.useState(false);
 const [showPrivacy, setShowPrivacy] = React.useState(false);
 const [phone, setPhone] = React.useState("");

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);      // start loading
  document.body.style.cursor = 'wait';

  const formData = {
   email: e.target.email.value,
   firstName: e.target.firstName.value,
   lastName: e.target.lastName.value,
   countryCode: countryCode,
   phone: phone,
   visaType: e.target.visaType.value,
   message: e.target.message.value,
  };

  try {
   await
   fetch('https://script.google.com/macros/s/AKfycbzJ9K50BzKrbqoSIJEjBmvHc8D4Y0SblAbV0CESwl899Uz9YyZPPpUrJi8_bLTApVdWXA/exec', {
   method: 'POST',
   mode: 'no-cors',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify(formData),
   });

   alert('Message sent! Our team will contact you soon.');
   e.target.reset();
   setCountryCode("");
  } catch (err) {
   alert('Could not send. Please try again later.');
   console.error(err);
  } finally {
   setIsSubmitting(false);     // stop loading
   document.body.style.cursor = 'default';
  }
 };

return (
<Container style={{ paddingTop: '38px', paddingBottom: '20px' }}>
<AppointmentWrapper>
<FormTitle>
Ready to Start your Study-Abroad Journey? 
</FormTitle>
<FormSubtitle>Fill the form below and our expert consultants will respond shortly.</FormSubtitle>


  <FormContainer onSubmit={handleSubmit}>
<Label>Email *</Label>
<Input
  name="email"
  type="email"
  placeholder="you@example.com"
  required
  pattern="^[^\s@]+@([^\s@]+\.)?(rediffmail|outlook|hotmail|yahoo|icloud|gmail)\.(com|co\.uk|co\.in|in|net)$"
  title="Use a valid email: rediffmail.com, outlook.com, hotmail.com, yahoo.com, yahoo.co.uk, yahoo.co.in, icloud.com, gmail.com"
/>



 <Row2>
  <div style={{ flex: 1 }}>
   <Label>First Name *</Label>
<Input
 name="firstName"
 type="text"
 placeholder="First Name"
 required
 pattern="^[A-Za-z\s]{2,40}$"
 title="Only letters and spaces, 2–40 characters"
/>
  </div>
  <div style={{ flex: 1 }}>
   <Label>Last Name *</Label>
<Input
 name="lastName"
 type="text"
 placeholder="Last Name"
 required
 pattern="^[A-Za-z\s]{2,40}$"
 title="Only letters and spaces, 2–40 characters"
/>  </div>
 </Row2>

 {/* Phone input as a single vertical field */}
 <div style={{ display: 'flex', flexDirection: 'column', marginTop: '8px' }}>
  <Label>Phone Number *</Label>
  <PhoneInput
   country={'in'}
   enableSearch={true}
   placeholder="Enter phone number"
   value={phone}
   onChange={(value, country) => {
   setPhone(value);
   setCountryCode(country?.dialCode || "");
   }}
   inputStyle={{
   width: '100%',
   height: '38px',
   fontSize: '0.9rem',
   borderRadius: '9px',
   border: `1px solid ${palette.goldBorder}`,
   background: palette.cream,
   color: palette.text,
   }}
   buttonStyle={{
   border: `1px solid ${palette.goldBorder}`,
   background: palette.cream,
   borderRadius: '9px 0 0 9px',
   }}
   dropdownStyle={{ zIndex: 1200 }}
  />
 </div>

 <Label>Visa Type *</Label>
 <Select name="visaType" required>
  <option value="">Select Visa Type</option>
  <option value="student">Student Visa</option>
  <option value="partner_student_work">Partner of Student Work Visa</option>
  <option value="dependent">Dependent Visa</option>
  <option value="post_study_work">Post-Study Work Visa</option>
 </Select>



   <Label>Message</Label>
   <Textarea name="message" placeholder="Tell us more" />

   <CheckboxLabel style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
   <Input 
     type="checkbox" 
     required 
     style={{ width: '18px', flexShrink: 0, accentColor: palette.green }} 
   />
   <label style={{ cursor: 'pointer', margin: 0 }}>
     I agree to{' '}
     <a 
     href="#"
     onClick={(e) => { e.preventDefault(); setShowPrivacy(true); }}
     style={{ color: palette.green, fontWeight: 600, textDecoration: 'underline', textDecorationColor: palette.gold }}
     >
     terms and privacy policy
     </a>{' '}
     *
   </label>
   </CheckboxLabel>

<SendBtn type="submit" disabled={isSubmitting}>
 {isSubmitting ? 'Requesting...' : 'Request a Call Back'}
</SendBtn>
   {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} />}

  </FormContainer>
 </AppointmentWrapper>
</Container>
);
}

// Scroll to top button component
function ScrollTop() {
 const [visible, setVisible] = React.useState(false);

 React.useEffect(() => {
  function onScroll() {
   setVisible(window.scrollY > 300);
  }
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
 }, []);

 function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
 }

 return (
  <ScrollTopButton
   visible={visible}
   onClick={scrollToTop}
   aria-label="Scroll to top"
   title="Scroll to top"
  >
   ↑
  </ScrollTopButton>
 );
}


export default function App() {
 return (
  <>
   <VersionChecker />
   <Router>
   <GlobalStyle />
   {/* <TopBar>
   <TopBarLeft>
     <span>Hyderabad, India</span>
     <span>Mon–Sat: 9AM to 6PM</span>
     <span>info@kiwiora.in</span>
   </TopBarLeft>
   <TopBarRight>
     <span>Any questions?</span>
     <TopBarPhone href="tel:+919849995490">+91 98499 95490</TopBarPhone>
   </TopBarRight>
   </TopBar> */}
   <Header />
   <main>
 <Routes>
  <Route
   path="/"
   element={
   <>
     <Hero />
     <TwoColumnSection>
     <ServicesPreview />
     <Appointment />
     </TwoColumnSection>
     <About />
     <FAQ />
   </>
   }
  />
    
     <Route path="/services" element={<Services />} />
     <Route path="/appointment" element={<Appointment />} />

     <Route path="/about" element={<About />} />
     {/* <Route path="/success-stories" element={<SuccessStories />} />
     <Route path="/success-stories" element={<SuccessStories />} /> */}
     <Route path="/help" element={<Help />} />
     <Route path="/contact" element={<Contact />} />
     <Route path="/get-started" element={<LeadGenerator />} />
     <Route path="/study-in-new-zealand-from-hyderabad" element={<StudyInNZ />} />

     </Routes>
   </main>
   <Footer />
   <ScrollTop />
   </Router>
  </>
 );
}